const KEEY_CFG=window.KEEY||{assetBase:'assets/optimized/',filesBase:'keey_videos/',buero:{}};
const KA=n=>KEEY_CFG.assetBase+n;
const KEEY_STEP=1000;
/* ===== APP LOGIC ===== */


/* =====================================================================
   KEEY KONFIGURATOR – Preisliste Juni 2026
   ---------------------------------------------------------------------
   Die Beispielprodukte und Platzhalterpreise wurden durch die aktuelle
   Preisliste ersetzt. Alle Stückpreise sind netto und inkl. Druck.
   ===================================================================== */
const $=id=>document.getElementById(id);
const fmt=n=>"€"+Number(n).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});
const fmtN=n=>Number(n).toLocaleString("de-DE");
const fmtUnit=n=>Number(n).toLocaleString("de-DE",{minimumFractionDigits:3,maximumFractionDigits:3})+" €";
const MWST=0.19;
const brutto=n=>n*(1+MWST);




function minUnitPrice(p){
  let vals=[];
  p.variants.forEach(v=>Object.values(v.prices).forEach(x=>vals.push(x)));
  const minOption = p.materials && p.materials.length ? Math.min(...p.materials.map(m=>Number(m.add || 0))) : 0;
  return Math.min(...vals) + minOption;
}
function maxUnitPrice(p){
  let vals=[];
  p.variants.forEach(v=>Object.values(v.prices).forEach(x=>vals.push(x)));
  return Math.max(...vals);
}
function derivedPriceLabel(p){
  return `ab ${minUnitPrice(p).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:3})} € / Stk`;
}

const PRODUCTS=[
  {
    id:'bowls', name:'Bowls inkl. Druck', cat:'Bowls',
    br:['delivery','gastro'],
    img:KA('bowl-dcf82ac8d63d.webp'), img2:KA('bowl-logo-b8a2dff943c1.webp'),
    gallery:[KA('bowl-highprotein-1d62a2a3a778.webp'),KA('bowl-schmarrn-bubble-b08f3c90358e.webp'),KA('bowl-shawafel-48a0960bd567.webp')],
    teaser:'500 ml bis 1300 ml · optional mit PET-Deckel',
    qtys:[10000,25000,50000],
    variants:[
      {label:'500 ml', prices:{10000:0.230,25000:0.190,50000:0.170}},
      {label:'500 ml mit PET Deckel', prices:{10000:0.240,25000:0.200,50000:0.180}},
      {label:'750 ml', prices:{10000:0.230,25000:0.190,50000:0.170}},
      {label:'750 ml mit PET Deckel', prices:{10000:0.240,25000:0.200,50000:0.180}},
      {label:'900 ml', prices:{10000:0.260,25000:0.220,50000:0.200}},
      {label:'900 ml mit PET Deckel', prices:{10000:0.270,25000:0.230,50000:0.210}},
      {label:'1000 ml', prices:{10000:0.290,25000:0.250,50000:0.230}},
      {label:'1000 ml mit PET Deckel', prices:{10000:0.300,25000:0.260,50000:0.240}},
      {label:'1300 ml', prices:{10000:0.330,25000:0.290,50000:0.270}},
      {label:'1300 ml mit PET Deckel', prices:{10000:0.340,25000:0.300,50000:0.280}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'becher', name:'Kaffeebecher inkl. Druck', cat:'Kaffeebecher',
    br:['coffee','gastro'],
    img:KA('kaffeebecher-080a1699120d.webp'), img2:KA('kaffee-becher-logo-94a6098d193a.webp'),
    gallery:[KA('becher-saya-group-407af472245c.webp'),KA('becher-waffle-74f966cc9ce2.webp'),KA('becher-rasakopi-stack-f79000de5b54.webp')],
    teaser:'Kaffeebecher in 4 oz, 8 oz und 12 oz – jeweils mit Deckel',
    qtys:[1000,5000,15000,25000],
    variants:[
      {label:'4 oz mit Deckel', prices:{1000:0.200,5000:0.150,15000:0.120,25000:0.110}},
      {label:'8 oz mit Deckel', prices:{1000:0.340,5000:0.290,15000:0.220,25000:0.200}},
      {label:'12 oz mit Deckel', prices:{1000:0.410,5000:0.362,15000:0.295,25000:0.270}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'clear-cups', name:'Clear Cup inkl. Druck', cat:'Clear Cups',
    br:['coffee','retail','gastro'],
    img:KA('clear-cup-round-lid-75f4ad0861cb.webp'), img2:KA('clear-cup-logo-d0559fbe8882.webp'),
    gallery:[KA('clear-cup-main-06e0382a2903.webp'),KA('clear-cup-dom-lid-dbc1ef9bde65.webp'),KA('clear-cup-flat-lid-d2ced004b308.webp')],
    teaser:'250 ml, 350 ml, 500 ml · mit Dom-, Flach- oder Trinkdeckel',
    qtys:[1000,5000,15000],
    variants:[
      {label:'250 ml', prices:{1000:0.250,5000:0.170,15000:0.140}},
      {label:'350 ml', prices:{1000:0.270,5000:0.180,15000:0.150}},
      {label:'500 ml', prices:{1000:0.290,5000:0.200,15000:0.170}}
    ],
    materialTitle:'Deckel auswählen',
    materials:[
      {label:'Dom Deckel', add:0.03, img:KA('clear-cup-dom-lid-dbc1ef9bde65.webp')},
      {label:'Flacher Deckel', add:0.03, img:KA('clear-cup-flat-lid-d2ced004b308.webp')},
      {label:'Trinkdeckel', add:0.03, img:KA('clear-cup-main-06e0382a2903.webp')}
    ],
    priceInfo:'Stückpreis netto inkl. Druck · gewählter Deckel inklusive'
  },
  {
    id:'tablettpapier', name:'Tablettpapier', cat:'Papiere',
    br:['gastro','retail','delivery'],
    img:KA('tablettpapier-176e2e8681b3.webp'), img2:KA('tablettpapier-logo-e0380981ae4a.webp'),
    gallery:[KA('tablettpapier-hot-chicks.jpg'),KA('tablettpapier-stories.jpg'),KA('tablettpapier-best-coffee.jpg')],
    teaser:'Markenpapier für Tabletts und Food-Präsentation · 30 × 40 cm und 31 × 43 cm',
    qtys:[50000,100000],
    variants:[
      {label:'30×40 cm', prices:{50000:0.040,100000:0.030}},
      {label:'31×43 cm', prices:{50000:0.040,100000:0.030}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'burger-box', name:'Burger Box', cat:'Boxen',
    br:['delivery','gastro'],
    img:KA('burger-box-518a79e767fe.webp'), img2:KA('burger-box-logo-76285aa47204.webp'),
    gallery:[KA('burger-box-hotchicks-fc524a228397.webp'),KA('burgerbox-hot-chicks-01.jpg'),KA('burgerbox-hogar.jpg'),KA('burgerbox-hot-chicks-02.jpg')],
    teaser:'Individuell bedruckte Burger- und Take-away-Boxen · 11 × 11 × 8 cm und 12 × 12 × 9,5 cm',
    qtys:[5000,10000,15000,20000,25000,30000,50000,100000],
    variants:[
      {label:'11×11×8 cm', prices:{5000:0.240,10000:0.200,15000:0.190,20000:0.140,25000:0.140,30000:0.130,50000:0.110,100000:0.110}},
      {label:'12×12×9,5 cm', prices:{5000:0.240,10000:0.200,15000:0.190,20000:0.140,25000:0.140,30000:0.130,50000:0.110,100000:0.110}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'feuchttuecher', name:'Erfrischungstücher', cat:'Hygiene',
    br:['gastro','delivery','retail'],
    img:KA('feuchttuecher-ee15ce489272.webp'), img2:KA('feuchttuecher-logo-e4a90b7cb3a3.webp'),
    gallery:[KA('erfrischungstuecher-7x12.jpg'),KA('press-tuecher-dose.jpg'),KA('press-tuecher-einzeln.jpg'),KA('erfrischungstuch-crusty-slices.jpg')],
    teaser:'Individuell bedruckte Erfrischungstücher · 7 × 12 cm oder als Press Tücher',
    qtys:[50000,100000],
    variants:[
      {label:'7×12 cm', prices:{50000:0.080,100000:0.070}},
      {label:'Press Tücher', prices:{50000:0.080,100000:0.070}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'tragetasche', name:'Tragetasche ohne Henkel', cat:'Taschen',
    br:['delivery','retail'],
    img:KA('tragetasche-f0ed5f3cebfa.webp'), img2:KA('tragetasche-ohne-henkel-logo-3100c84f216b.webp'),
    gallery:[KA('tragetasche-ohne-griff-burgerheld.jpg')],
    teaser:'Papiertragetasche ohne Henkel · 27 × 15 × 33 cm',
    qtys:[10000,15000,20000,30000,50000,100000],
    variants:[
      {label:'27×15×33 cm', prices:{10000:0.200,15000:0.190,20000:0.180,30000:0.160,50000:0.150,100000:0.120}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'tragetasche-henkel', name:'Tragetasche mit Henkel', cat:'Taschen',
    br:['delivery','retail'],
    img:KA('tragetasche-mit-henkel-38cffd9f6458.webp'), img2:KA('tragetasche-mit-henkel-logo-448813dfd8ef.webp'),
    gallery:[KA('tragetasche-mit-griff-sevenone.jpg')],
    teaser:'Papiertragetasche mit Henkel · 27 × 15 × 33 cm',
    qtys:[10000,15000,20000,30000,50000,100000],
    variants:[
      {label:'27×15×33 cm', prices:{10000:0.240,15000:0.230,20000:0.220,30000:0.200,50000:0.190,100000:0.160}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck · mit Henkel (+0,04 € / Stk)'
  },
  {
    id:'wickelpapier-30', name:'Wickelpapier 30×30 cm', cat:'Papiere',
    br:['gastro','delivery'],
    img:KA('wickelpapier-7ab5975e693f.webp'), img2:KA('wickelpapier-30-logo-82cdb260b01f.webp'),
    gallery:[KA('wickelpapier-shawafel.jpg')],
    teaser:'Bedrucktes Wickelpapier für Döner, Snacks und Take-away · 30 × 30 cm',
    qtys:[50000,100000],
    variants:[
      {label:'30×30 cm', prices:{50000:0.033,100000:0.029}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'doenerpapier-16', name:'Dönerpapier 16×16 cm', cat:'Papiere',
    br:['gastro','delivery'],
    img:KA('doenerpapier-16-5512366dcaaf.webp'), img2:KA('doenerpapier-16-logo-e2d2d754619d.webp'),
    gallery:[KA('doenerpapier-kebabry.jpg'),KA('doenerpapier-doener-kebab.jpg')],
    teaser:'Bedrucktes Dönerpapier für Döner & Snacks · 16 × 16 cm',
    qtys:[50000,100000],
    variants:[
      {label:'16×16 cm', prices:{50000:0.033,100000:0.029}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  },
  {
    id:'pizza-karton', name:'Pizzakarton', cat:'Pizzakartons',
    br:['delivery','pizzeria'],
    img:KA('pizza-box-efd7878d388e.webp'), img2:KA('pizzakarton-logo-e7aa215d72be.webp'),
    gallery:[KA('pizzakarton-pizzaheld.jpg')],
    teaser:'28er bis 40×60',
    qtys:[10000,15000,20000],
    variants:[
      {label:'28er', prices:{10000:0.320,15000:0.220,20000:0.210}},
      {label:'30er', prices:{10000:0.350,15000:0.235,20000:0.230}},
      {label:'32er', prices:{10000:0.390,15000:0.245,20000:0.240}},
      {label:'40er', prices:{10000:0.550,15000:0.370,20000:0.365}},
      {label:'40×60', prices:{10000:0.950,15000:0.800,20000:0.750}}
    ],
    priceInfo:'Stückpreis netto inkl. Druck'
  }
];

const VARIANT_IDS={"becher-0-1000":54282493591899,"becher-0-5000":54282493624667,"becher-0-15000":54282493657435,"becher-0-25000":54282493690203,"becher-1-1000":54282493722971,"becher-1-5000":54282493755739,"becher-1-15000":54282493788507,"becher-1-25000":54282493821275,"becher-2-1000":54282493854043,"becher-2-5000":54282493886811,"becher-2-15000":54282493919579,"becher-2-25000":54282493952347,"tablettpapier-0-50000":54282546086235,"tablettpapier-0-100000":54282546119003,"tablettpapier-1-50000":54282546151771,"tablettpapier-1-100000":54282546184539,"feuchttuecher-0-50000":54282546512219,"feuchttuecher-0-100000":54282546544987,"feuchttuecher-1-50000":54282546577755,"feuchttuecher-1-100000":54282546610523,"wickelpapier-30-0-50000":54282548412763,"wickelpapier-30-0-100000":54282548445531,"doenerpapier-16-0-50000":54282583146843,"doenerpapier-16-0-100000":54282583179611,"tragetasche-0-10000":54282595959131,"tragetasche-0-15000":54282595991899,"tragetasche-0-20000":54282596024667,"tragetasche-0-30000":54282596057435,"tragetasche-0-50000":54282596090203,"tragetasche-0-100000":54282596122971,"tragetasche-henkel-0-10000":54282604544347,"tragetasche-henkel-0-15000":54282604577115,"tragetasche-henkel-0-20000":54282604609883,"tragetasche-henkel-0-30000":54282604642651,"tragetasche-henkel-0-50000":54282604675419,"tragetasche-henkel-0-100000":54282604708187,"pizza-karton-0-10000":54282617094491,"pizza-karton-0-15000":54282617127259,"pizza-karton-0-20000":54282617160027,"pizza-karton-1-10000":54282617192795,"pizza-karton-1-15000":54282617225563,"pizza-karton-1-20000":54282617258331,"pizza-karton-2-10000":54282617291099,"pizza-karton-2-15000":54282617323867,"pizza-karton-2-20000":54282617356635,"pizza-karton-3-10000":54282617389403,"pizza-karton-3-15000":54282617422171,"pizza-karton-3-20000":54282617454939,"pizza-karton-4-10000":54282617487707,"pizza-karton-4-15000":54282617520475,"pizza-karton-4-20000":54282617553243,"burger-box-0-5000":54282636788059,"burger-box-0-10000":54282636820827,"burger-box-0-15000":54282636853595,"burger-box-0-20000":54282636886363,"burger-box-0-25000":54282636919131,"burger-box-0-30000":54282636951899,"burger-box-0-50000":54282636984667,"burger-box-0-100000":54282637017435,"burger-box-1-5000":54282637050203,"burger-box-1-10000":54282637082971,"burger-box-1-15000":54282637115739,"burger-box-1-20000":54282637148507,"burger-box-1-25000":54282637181275,"burger-box-1-30000":54282637214043,"burger-box-1-50000":54282637246811,"burger-box-1-100000":54282637279579,"clear-cups-0-0-1000":54282664345947,"clear-cups-0-0-5000":54282664378715,"clear-cups-0-0-15000":54282664411483,"clear-cups-0-1-1000":54282664444251,"clear-cups-0-1-5000":54282664477019,"clear-cups-0-1-15000":54282664509787,"clear-cups-0-2-1000":54282664542555,"clear-cups-0-2-5000":54282664575323,"clear-cups-0-2-15000":54282664608091,"clear-cups-1-0-1000":54282664640859,"clear-cups-1-0-5000":54282664673627,"clear-cups-1-0-15000":54282664706395,"clear-cups-1-1-1000":54282664739163,"clear-cups-1-1-5000":54282664771931,"clear-cups-1-1-15000":54282664804699,"clear-cups-1-2-1000":54282664837467,"clear-cups-1-2-5000":54282664870235,"clear-cups-1-2-15000":54282664903003,"clear-cups-2-0-1000":54282664935771,"clear-cups-2-0-5000":54282664968539,"clear-cups-2-0-15000":54282665001307,"clear-cups-2-1-1000":54282665034075,"clear-cups-2-1-5000":54282665066843,"clear-cups-2-1-15000":54282665099611,"clear-cups-2-2-1000":54282665132379,"clear-cups-2-2-5000":54282665165147,"clear-cups-2-2-15000":54282665197915,"bowls-0-10000":54282696130907,"bowls-0-25000":54282696163675,"bowls-0-50000":54282696196443,"bowls-1-10000":54282696229211,"bowls-1-25000":54282696261979,"bowls-1-50000":54282696294747,"bowls-2-10000":54282696327515,"bowls-2-25000":54282696360283,"bowls-2-50000":54282696393051,"bowls-3-10000":54282696425819,"bowls-3-25000":54282696458587,"bowls-3-50000":54282696491355,"bowls-4-10000":54282696524123,"bowls-4-25000":54282696556891,"bowls-4-50000":54282696589659,"bowls-5-10000":54282696622427,"bowls-5-25000":54282696655195,"bowls-5-50000":54282696687963,"bowls-6-10000":54282696720731,"bowls-6-25000":54282696753499,"bowls-6-50000":54282696786267,"bowls-7-10000":54282696819035,"bowls-7-25000":54282696851803,"bowls-7-50000":54282696884571,"bowls-8-10000":54282696917339,"bowls-8-25000":54282696950107,"bowls-8-50000":54282696982875,"bowls-9-10000":54282697015643,"bowls-9-25000":54282697048411,"bowls-9-50000":54282697081179};
function variantIdFor(p,sizeIdx,matIdx,tier){
  const hasMat=p.materials&&p.materials.length;
  return VARIANT_IDS[p.id+'-'+(sizeIdx||0)+(hasMat?'-'+(matIdx||0):'')+'-'+tier]||null;
}
const CATS=['Alle',...new Set(PRODUCTS.map(p=>p.cat))];
const BRANCHEN=[['alle','Alle Anwendungen'],['delivery','Delivery'],['coffee','Coffee Shops'],['gastro','Gastronomie'],['retail','Retail'],['pizzeria','Pizzeria']];
const BR_NAMES={delivery:'Delivery',coffee:'Coffee Shops',gastro:'Gastronomie',retail:'Retail',pizzeria:'Pizzeria'};

let curCat='Alle', curBr='alle', curQ='';
const cart=[];
let cur=null;
let curState={sizeIdx:0,matIdx:0,qty:1000,gallery:[],galIdx:0};

function productById(id){ return PRODUCTS.find(p=>p.id===id); }
function snapQty(product, qty){
  if(!product) return qty;
  const min = product.qtys[0];
  const n = Number.parseInt(qty,10);
  const v = Number.isFinite(n) ? n : min;
  return Math.max(min, Math.round(v/KEEY_STEP)*KEEY_STEP);
}
function priceTierForQty(product, qty){
  const q = snapQty(product, qty);
  return product.qtys.reduce((tier, candidate)=>candidate<=q ? candidate : tier, product.qtys[0]);
}
function selectedVariant(product, idx){
  return product.variants[idx] || product.variants[0];
}
function materialLabel(product, idx){
  return product.materials && product.materials.length ? product.materials[idx].label : '';
}
function materialAdd(product, idx){
  return product.materials && product.materials.length ? Number(product.materials[idx].add || 0) : 0;
}
function calcPrice(product, sizeIdx, qty){
  const q = snapQty(product, qty);
  const tier = priceTierForQty(product, q);
  const variant = selectedVariant(product, sizeIdx);
  const unit = Number(variant.prices[tier] ?? Object.values(variant.prices)[0]);
  return (unit + materialAdd(product, curState.matIdx||0)) * q;
}
function calcItemPrice(item){
  const product = productById(item.id);
  const q = snapQty(product, item.qty);
  const tier = priceTierForQty(product, q);
  const variant = selectedVariant(product, item.sizeIdx);
  const unit = Number(variant.prices[tier] ?? Object.values(variant.prices)[0]);
  return (unit + (item.matAdd || 0)) * q;
}
function unitPriceForItem(item){
  return item.price / item.qty;
}
function shortSpec(item, withQty=false){
  const bits=[];
  if(item.size && item.size!=='Standard') bits.push(item.size);
  if(item.mat) bits.push(item.mat);
  if(withQty) bits.push(`${fmtN(item.qty)} Stück`);
  bits.push('inkl. Druck');
  bits.push('Versand in Deutschland');
  return bits.join(' · ');
}
function offerSpec(item){
  const bits=[];
  if(item.size && item.size!=='Standard') bits.push(item.size);
  if(item.mat) bits.push(item.mat);
  bits.push('inkl. Druck');
  bits.push('Versand in Deutschland');
  return bits.join(' · ');
}

function buildChips(){
  $('catRow').innerHTML=CATS.map(c=>`<button class="chip${c===curCat?' on':''}" onclick="setCat('${c}')">${c}</button>`).join('');
  $('brRow').innerHTML=BRANCHEN.map(([k,l])=>`<button class="chip${k===curBr?' on':''}" onclick="setBr('${k}')">${l}</button>`).join('');
}
function setCat(c){ curCat=c; buildChips(); renderGrid(); }
function setBr(k){ curBr=k; buildChips(); renderGrid(); }
$('q').addEventListener('input',e=>{ curQ=e.target.value.toLowerCase(); renderGrid(); });
function filtered(){
  return PRODUCTS.filter(p=>
    (curCat==='Alle' || p.cat===curCat) &&
    (curBr==='alle' || p.br.includes(curBr)) &&
    (!curQ || `${p.name} ${p.teaser}`.toLowerCase().includes(curQ))
  );
}

function renderFeatured(){
  const el=$('featuredGrid');
  if(!el) return;
  el.innerHTML = PRODUCTS.map(p=>`
    <article class="featured-card" onclick="openProduct('${p.id}')">
      <div class="img"><img loading="lazy" src="${p.img}" alt="${p.name}"></div>
      <div class="body">
        <span class="kicker">${p.cat}</span>
        <h3>${p.name}</h3>
        <p>${p.teaser}</p>
        <div class="meta"><span class="from">${derivedPriceLabel(p)}</span><span class="cta">Zur Bestellung ›</span></div>
      </div>
    </article>`).join('');
}

const LANDING_PAGES={"bowls": "bowls-bedrucken", "becher": "kaffeebecher-bedrucken", "clear-cups": "clear-cups-bedrucken", "tablettpapier": "tablettpapier-bedrucken", "burger-box": "burger-box-bedrucken", "feuchttuecher": "feuchttuecher-bedrucken", "tragetasche": "tragetasche-ohne-henkel-bedrucken", "tragetasche-henkel": "tragetasche-mit-henkel-bedrucken", "wickelpapier-30": "wickelpapier-bedrucken", "doenerpapier-16": "doenerpapier-bedrucken", "pizza-karton": "pizzakartons-bedrucken"};
function renderGrid(){
  const list=filtered();
  $('rc').textContent=list.length+' Produkte';
  $('empty').style.display=list.length?'none':'block';
  $('grid').innerHTML=list.map(p=>{
    const inCart=cart.some(c=>c.id===p.id);
    const lp=LANDING_PAGES[p.id];
    return `<div class="pcard${inCart?' sel':''}" onclick="openConfig('${p.id}')">
      <div class="imgwrap"><img loading="lazy" src="${p.img}" alt="${p.name}"></div>
      <div class="body">
        <span class="cat">${p.cat}</span>
        <h3>${p.name}</h3>
        <span class="price"><b>${derivedPriceLabel(p)}</b></span>
        ${lp?`<a class="pcard-more" href="/pages/${lp}" onclick="event.stopPropagation()">Mehr erfahren →</a>`:''}
        <button class="cfg" onclick="event.stopPropagation();openConfig('${p.id}')">${inCart?'✓ Konfiguriert':'Bestellen'}</button>
      </div></div>`;
  }).join('');
}

function openConfig(id){
  cur = productById(id);
  curState = {sizeIdx:0, matIdx:0, qty:cur.qtys[0], gallery:[cur.img, cur.img2, ...(cur.gallery||[])].filter((g,i,a)=>g && a.indexOf(g)===i), galIdx:0};
  $('mCat').textContent = cur.cat;
  $('mName').textContent = cur.name;
  $('gMain').src = curState.gallery[0];
  $('gMain').alt = cur.name;
  $('gThumbs').innerHTML = curState.gallery.length>1 ? curState.gallery.map((g,i)=>`<img src="${g}" class="${i===0?'on':''}" onclick="setGal(${i})">`).join('') : '';

  const sizes = cur.variants;
  const showSize = sizes.length>1 || (sizes[0] && sizes[0].label && sizes[0].label !== 'Standard');
  $('grpSize').style.display = showSize ? 'block' : 'none';
  $('sizeHint').textContent = sizes.length>1 ? 'Variante' : 'Maße';
  $('sizeOpts').innerHTML = sizes.map((s,i)=>`<button class="opt${i===0?' on':''}" onclick="setSize(${i})">${s.label}</button>`).join('');

  $('grpMaterial').style.display = cur.materials && cur.materials.length ? 'block' : 'none';
  $('materialTitle').textContent = cur.materialTitle || 'Material';
  $('matOpts').innerHTML = cur.materials && cur.materials.length ? cur.materials.map((m,i)=>`<button class="opt${m.img?' with-img':''}${i===0?' on':''}" onclick="setMat(${i})">${m.img?`<img src="${m.img}" alt="">`:''}<span>${m.label}</span></button>`).join('') : '';

  $('qtyPresets').innerHTML = cur.qtys.map(v=>`<button class="opt" data-q="${v}" onclick="setQty(${v})">${fmtN(v)}</button>`).join('');
  $('qtyInput').value = cur.qtys[0];
  $('qtyInput').min = cur.qtys[0];
  $('qtyInput').step = KEEY_STEP;
  $('minQtyHint').textContent = `Mindestmenge ${fmtN(cur.qtys[0])} Stück · in 1.000er-Schritten`;

  const colorGroup = $('colorOpts').closest('.opt-group');
  colorGroup.style.display='block';
  colorGroup.querySelector('.lbl span').textContent='Druck';
  colorGroup.querySelector('.hint').textContent='inklusive';
  $('colorOpts').innerHTML = `<div class="price-note-inline">${cur.priceInfo || 'Individueller Druck ist bereits im Preis enthalten.'}</div>`;

  syncQtyUI();
  updatePrice();
  $('modalBg').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeModal(){ $('modalBg').classList.remove('open'); document.body.style.overflow=''; cur=null; }
function setGal(i){ curState.galIdx=i; $('gMain').src=curState.gallery[i]; [...$('gThumbs').children].forEach((t,j)=>t.classList.toggle('on',j===i)); }
function markOn(container,idx){ [...container.children].forEach((b,i)=>b.classList.toggle('on',i===idx)); }
function setSize(i){ curState.sizeIdx=i; markOn($('sizeOpts'),i); updatePrice(); }
function setMat(i){
  curState.matIdx=i;
  markOn($('matOpts'),i);
  const option = cur.materials && cur.materials[i];
  if(option && option.img){
    const galleryIndex = curState.gallery.indexOf(option.img);
    if(galleryIndex>=0) setGal(galleryIndex);
  }
  updatePrice();
}
function setQty(v){ curState.qty=snapQty(cur,v); $('qtyInput').value=curState.qty; syncQtyUI(); updatePrice(); }
function bumpQty(dir){
  setQty(curState.qty + (dir>0 ? KEEY_STEP : -KEEY_STEP));
}
$('qtyInput').addEventListener('input',()=>{ if(!cur) return; setQty($('qtyInput').value); });
$('qtyInput').addEventListener('blur',()=>{ if(cur) setQty($('qtyInput').value); });
function syncQtyUI(){
  [...$('qtyPresets').children].forEach(b=>b.classList.toggle('on', Number(b.dataset.q)===curState.qty));
  $('qtyNote').textContent = `Verfügbare Preisstaffeln: ${cur.qtys.map(q=>fmtN(q)).join(' · ')} Stück`;
}
function updatePrice(){
  const q = snapQty(cur, curState.qty);
  const tier = priceTierForQty(cur, q);
  const variant = selectedVariant(cur, curState.sizeIdx);
  const unit = Number(variant.prices[tier]) + materialAdd(cur, curState.matIdx);
  const total = unit * q;
  $('pTotal').textContent = fmt(total);
  $('pBrutto').textContent = fmt(brutto(total));
  $('pPer').textContent = `${unit.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:3})} € netto / Stück`;
}

function recalc(c){
  const p = productById(c.id);
  c.qty = snapQty(p, c.qty);
  c.price = calcItemPrice(c);
  c.shopifyVariantId = variantIdFor(p, c.sizeIdx, c.matIdx, priceTierForQty(p, c.qty));
}
function addCurrent(){
  const q = snapQty(cur, curState.qty);
  const tier = priceTierForQty(cur, q);
  const variant = selectedVariant(cur, curState.sizeIdx);
  const item = {
    uid:Date.now()+"-"+Math.random().toString(36).slice(2,6),
    id:cur.id, name:cur.name, cat:cur.cat, img:cur.img,
    size: variant.label || 'Standard', sizeIdx:curState.sizeIdx,
    mat: materialLabel(cur, curState.matIdx), matIdx:curState.matIdx, matAdd: materialAdd(cur, curState.matIdx),
    qty:q, colors:1,
    shopifyVariantId:variantIdFor(cur, curState.sizeIdx, curState.matIdx, tier),
    price:(Number(variant.prices[tier]) + materialAdd(cur, curState.matIdx)) * q
  };
  cart.push(item);
  updateCart(); renderGrid(); closeModal(); goCart(); openPanel();
  toast('Zum Warenkorb hinzugefügt');
}
function removeItem(uid){ const i=cart.findIndex(c=>c.uid===uid); if(i>-1) cart.splice(i,1); updateCart(); renderGrid(); }
function itemQty(uid,v){ const c=cart.find(x=>x.uid===uid); if(!c) return;
  if(c.fixed){ const n=Number.parseInt(v,10); c.qty=Math.max(1,Number.isFinite(n)?n:1); c.price=(c.unit||c.price)*c.qty; updateCart(); return; }
  c.qty=snapQty(productById(c.id), v); recalc(c); updateCart(); }
function itemBump(uid,d){
  const c=cart.find(x=>x.uid===uid); if(!c) return;
  itemQty(uid,c.qty + (d>0 ? 1 : -1)*(c.fixed?1:KEEY_STEP));
}
function cartSum(){ return cart.reduce((a,c)=>a+c.price,0); }

function updateCart(){
  const n=cart.length, sum=cartSum();
  $('cartCount').textContent=n;
  $('barCount').textContent=n+(n===1?' Position':' Positionen');
  $('barSum').textContent=fmt(sum);
  $('grandTotal').textContent=fmt(sum);
  $('grandBrutto').textContent=fmt(brutto(sum));
  $('reviewTotal').textContent=fmt(sum);
  $('reviewBrutto').textContent=fmt(brutto(sum));
  $('cartItemsN').textContent=n?('· '+n+(n===1?' Position':' Positionen')):'';
  $('bar').classList.toggle('show',n>0&&!$('panel').classList.contains('open'));
  $('toReview').classList.toggle('dim',n===0);

  $('items').innerHTML=n?cart.map(c=>`
    <div class="pitem">
      <img src="${c.img}" alt="">
      <div style="flex:1">
        <div class="nm">${c.name}</div>
        <div class="spec">${shortSpec(c,false)}</div>
        <div class="miniqty">
          <button onclick="itemBump('${c.uid}',-1)">−</button>
          <input type="number" value="${c.qty}" step="${c.fixed?1:KEEY_STEP}" inputmode="numeric" onchange="itemQty('${c.uid}',this.value)" onblur="itemQty('${c.uid}',this.value)">
          <span class="u">Stk</span>
          <button onclick="itemBump('${c.uid}',1)">+</button>
        </div>
        <div class="pp">${fmt(c.price)} <span class="pp-brutto">netto · ${fmt(brutto(c.price))} brutto</span></div>
      </div>
      <button class="rm" onclick="removeItem('${c.uid}')" title="Entfernen">✕</button>
    </div>`).join('') : `<div class="empty">Dein Warenkorb ist leer.<br>Wähle ein Produkt aus der Produktübersicht.</div>`;

  $('reviewItems').innerHTML=n?cart.map((c,i)=>`
    <div class="revline">
      <div class="no">${i+1}</div>
      <div style="flex:1">
        <div class="nm">${c.name}</div>
        <div class="spec">${shortSpec(c,true)}</div>
      </div>
      <div class="lp">${fmt(c.price)}<span class="lp-brutto">${fmt(brutto(c.price))} brutto</span></div>
    </div>`).join('') : `<div class="empty">Keine Positionen.</div>`;

  $('makeAngebot').classList.toggle('dim',n===0);
}

function orderText(){
  const lines=cart.map((c,i)=>`${i+1}. ${c.name}: ${shortSpec(c,true)} — ${fmt(c.price)} netto / ${fmt(brutto(c.price))} brutto`);
  return `KEEY Bestellliste\n\n${lines.join("\n")}\n\nSumme netto: ${fmt(cartSum())}\nSumme brutto (inkl. 19% MwSt): ${fmt(brutto(cartSum()))}`;
}
function copyOrder(){
  if(!cart.length){ toast('Liste ist leer'); return; }
  const t=orderText();
  if(navigator.clipboard&&navigator.clipboard.writeText){
    navigator.clipboard.writeText(t).then(()=>toast('Liste kopiert'),()=>fallbackCopy(t));
  } else fallbackCopy(t);
}
function fallbackCopy(t){ const ta=document.createElement('textarea'); ta.value=t; document.body.appendChild(ta); ta.select(); try{ document.execCommand('copy'); toast('Liste kopiert'); }catch(e){ toast('Kopieren nicht möglich'); } document.body.removeChild(ta); }

/* ---------- BESTELLUNG / SHOPIFY CHECKOUT ---------- */
let docType='bestellung';
let _agNo=null;
const SELLER={
  name:'KEEY GmbH', street:'Bräuersdorf 28', city:'91469 Hagenbüchach',
  phone:'+49 911 47778350', mail:'info@keey.de',
  ust:'DE326760672', reg:'HRB 733407 · Amtsgericht Fürth', ceo:'Timur Sakanci',
  logo:KA('keey-logo.png')
};
function escHtml(s){ return String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c])); }
function agVal(id){ const e=document.getElementById(id); return e?e.value.trim():''; }
function agPh(v,placeholder){ return v?escHtml(v):'<span class="ang-ph">'+placeholder+'</span>'; }
function deDate(d){ return d.toLocaleDateString('de-DE',{day:'2-digit',month:'long',year:'numeric'}); }
function agNo(){
  if(!_agNo){ const d=new Date(),p=n=>String(n).padStart(2,'0'); _agNo=`${d.getFullYear()}${p(d.getMonth()+1)}${p(d.getDate())}-${Math.floor(1000+Math.random()*9000)}`; }
  return (docType==='bestellung'?'BE-':'AN-')+_agNo;
}
function openBestellung(){
  if(!cart.length){ toast('Warenkorb ist leer'); return; }
  docType='bestellung';
  _agNo=null;
  closePanel();
  document.getElementById('angebotOverlay').classList.add('open');
  document.body.style.overflow='hidden';
  const status=document.getElementById('shopifyStatus');
  if(status){status.className='shopify-status';status.textContent='Kreditkarte · PayPal · Klarna · Apple Pay – abhängig von den aktivierten Shopify-Zahlungsarten.';}
  renderAngebot();
}
function openAngebot(){ openBestellung(); }
function closeAngebot(){
  document.getElementById('angebotOverlay').classList.remove('open');
  document.body.style.overflow='';
}
function setDocType(t){
  docType='bestellung';
  document.querySelectorAll('#docToggle .dt').forEach(b=>b.classList.toggle('on',b.dataset.type===t));
  renderAngebot();
}

async function startShopifyCheckout(){
  if(!cart.length){ toast('Warenkorb ist leer'); return; }
  const status=document.getElementById('shopifyStatus');
  const missing=cart.filter(item=>!item.shopifyVariantId);
  if(missing.length){
    if(status){
      status.className='shopify-status warn';
      status.textContent='Der sichere Checkout ist vorbereitet. Vor der Veröffentlichung müssen die Shopify-Varianten-IDs noch mit diesen Produkten verbunden werden.';
    }
    toast('Shopify-Produktvarianten müssen noch verbunden werden');
    return;
  }
  const btn=document.getElementById('agMail');
  const oldText=btn?btn.textContent:'';
  if(btn){btn.textContent='Checkout wird geöffnet …';btn.disabled=true;}
  try{
    const headers={'Content-Type':'application/json','Accept':'application/json'};
    await fetch('/cart/clear.js',{method:'POST',headers,body:JSON.stringify({})});
    const items=cart.map(item=>({
      id:Number(item.shopifyVariantId),
      quantity:item.fixed?item.qty:Math.round(item.qty/KEEY_STEP),
      properties:item.fixed?{}:{
        'Produktmenge':fmtN(item.qty)+' Stück',
        'Ausführung':[item.size,item.mat].filter(Boolean).join(' · ')||'Standard',
        'Leistung':'inkl. Druck',
        'Versand':'Deutschland'
      }
    }));
    await fetch('/cart/add.js',{method:'POST',headers,body:JSON.stringify({items})}).then(r=>{if(!r.ok)throw new Error('cart');return r.json();});
    const attributes={
      'Firma':agVal('agFirma'),
      'Ansprechpartner':agVal('agName'),
      'Telefon':agVal('agPhone'),
      'Bestellreferenz':agNo()
    };
    await fetch('/cart/update.js',{method:'POST',headers,body:JSON.stringify({note:agVal('agNote'),attributes})});
    if(status){status.className='shopify-status ok';status.textContent='Warenkorb übertragen. Der sichere Shopify Checkout wird geöffnet …';}
    window.location.href='/checkout';
  }catch(err){
    if(status){status.className='shopify-status warn';status.textContent='Der Shopify Checkout konnte nicht geöffnet werden. Bitte prüfe Shop-Domain, Varianten-IDs und Shopify-Verbindung.';}
    toast('Checkout konnte nicht geöffnet werden');
    if(btn){btn.textContent=oldText||'Sicher bezahlen';btn.disabled=false;}
  }
}
function renderAngebot(){
  const doc=document.getElementById('angDoc'); if(!doc) return;
  const isOrder=docType==='bestellung';
  const net=cartSum(), tax=net*MWST, gross=net+tax;
  const rows=cart.map((c,i)=>{
    const unit=c.qty>0?c.price/c.qty:0;
    return '<tr>'
      +'<td class="no">'+(i+1)+'</td>'
      +'<td>'+escHtml(c.name)+'<div class="psub">'+escHtml(offerSpec(c))+'</div></td>'
      +'<td class="r">'+fmtN(c.qty)+'</td>'
      +'<td class="r">'+unit.toLocaleString('de-DE',{minimumFractionDigits:3,maximumFractionDigits:3})+' €</td>'
      +'<td class="r">'+fmt(c.price)+'</td>'
    +'</tr>';
  }).join('');
  const email=agVal('agEmail'), phone=agVal('agPhone');
  doc.innerHTML=
   '<div class="hd">'
    +'<img src="'+SELLER.logo+'" alt="KEEY">'
    +'<div class="seller"><b>'+SELLER.name+'</b><br>'+SELLER.street+'<br>'+SELLER.city+'<br>Tel. '+SELLER.phone+'<br>'+SELLER.mail+'</div>'
   +'</div>'
   +'<div class="meta-row">'
    +'<div class="cust">'
      +'<div class="to">'+(isOrder?'Bestellung von':'Angebot für')+'</div>'
      +'<b>'+agPh(agVal('agFirma'),'Firma')+'</b><br>'
      +agPh(agVal('agName'),'Ansprechpartner')+'<br>'
      +agPh(agVal('agStreet'),'Straße & Hausnr.')+'<br>'
      +agPh(agVal('agCity'),'PLZ & Ort')
      +(email?'<br>'+escHtml(email):'')
      +(phone?'<br>'+escHtml(phone):'')
    +'</div>'
    +'<div class="info"><table>'
      +'<tr><td>'+(isOrder?'Bestell-Nr.':'Angebots-Nr.')+'</td><td>'+agNo()+'</td></tr>'
      +'<tr><td>Datum</td><td>'+deDate(new Date())+'</td></tr>'
      +(isOrder?'':'<tr><td>Gültig bis</td><td>'+deDate(new Date(Date.now()+30*864e5))+'</td></tr>')
      +'<tr><td>Positionen</td><td>'+cart.length+'</td></tr>'
    +'</table></div>'
   +'</div>'
   +'<h1 class="angtitle">'+(isOrder?'Bestellung':'Angebot')+'</h1>'
   +'<div class="subtitle">Verbindliche Bestellung – alle Produktpreise netto zzgl. 19% MwSt. und inkl. Druck. Versand in Deutschland wird im Checkout ausgewiesen.</div>'
   +'<table class="pos"><thead><tr><th class="no">#</th><th>Beschreibung</th><th class="r">Menge</th><th class="r">Einzelpreis</th><th class="r">Gesamt</th></tr></thead><tbody>'+rows+'</tbody></table>'
   +'<div class="totals">'
    +'<div class="tr"><span>Zwischensumme netto</span><span>'+fmt(net)+'</span></div>'
    +'<div class="tr muted"><span>zzgl. 19% MwSt.</span><span>'+fmt(tax)+'</span></div>'
    +'<div class="tr grand"><span>Gesamt</span><span>'+fmt(gross)+'</span></div>'
   +'</div>'
   +(agVal('agNote')?'<div class="terms"><b>Anmerkungen:</b> '+escHtml(agVal('agNote'))+'</div>':'')
   +'<div class="terms"><b>Hinweise:</b> '
     +'Mit dem erfolgreichen Abschluss der Zahlung wird die Bestellung in Shopify angelegt und KEEY automatisch benachrichtigt. '
     +'Alle Produktpreise verstehen sich netto in Euro zzgl. 19% MwSt. und inkl. Druck. Der Versand in Deutschland wird im Checkout ausgewiesen. Finale Druckdaten und Freigabe werden separat abgestimmt. Es gelten die AGB der '+SELLER.name+'.</div>'
   +'<div class="docfoot">'
     +'<div><b>'+SELLER.name+'</b><br>'+SELLER.street+', '+SELLER.city+'<br>Geschäftsführer: '+SELLER.ceo+'</div>'
     +'<div><b>Kontakt</b><br>Tel. '+SELLER.phone+'<br>'+SELLER.mail+'</div>'
     +'<div><b>Register</b><br>'+SELLER.reg+'<br>USt-IdNr. '+SELLER.ust+'</div>'
   +'</div>';
}
function printAngebot(){
  const old=document.title;
  document.title='KEEY_'+(docType==='bestellung'?'Bestellung':'Angebot')+'_'+agNo();
  window.print();
  setTimeout(()=>{document.title=old;},600);
}
function downloadAngebot(){
  if(!cart.length){ toast('Warenkorb ist leer'); return; }
  const doc=document.getElementById('angDoc');
  if(!doc){ return; }
  if(typeof html2pdf==='undefined'){ printAngebot(); return; }
  const fname='KEEY_'+(docType==='bestellung'?'Bestellung':'Angebot')+'_'+agNo()+'.pdf';
  const btn=document.getElementById('agDownload');
  const oldTxt=btn?btn.textContent:'';
  if(btn){ btn.textContent='PDF wird erstellt …'; btn.style.pointerEvents='none'; btn.style.opacity='.7'; }
  const opt={
    margin:[10,10,12,10],
    filename:fname,
    image:{type:'jpeg',quality:0.98},
    html2canvas:{scale:2,useCORS:true,backgroundColor:'#ffffff',logging:false},
    jsPDF:{unit:'mm',format:'a4',orientation:'portrait'},
    pagebreak:{mode:['css','legacy']}
  };
  const restore=()=>{ if(btn){ btn.textContent=oldTxt||'PDF herunterladen'; btn.style.pointerEvents=''; btn.style.opacity=''; } };
  Promise.resolve(html2pdf().set(opt).from(doc).save())
    .then(()=>{ restore(); toast('PDF gespeichert'); })
    .catch(()=>{ restore(); toast('PDF-Erstellung fehlgeschlagen – Druckdialog wird geöffnet'); printAngebot(); });
}
function mailAngebot(){
  if(!cart.length){ toast('Warenkorb ist leer'); return; }
  const subj=(docType==='bestellung'?'Bestellung':'Angebot')+' '+agNo()+' – KEEY';
  const lines=cart.map((c,i)=>(i+1)+'. '+c.name+' – '+offerSpec(c)+' – '+fmtN(c.qty)+' Stk – '+fmt(c.price)+' netto');
  const body=(docType==='bestellung'?'Hiermit bestelle ich folgende Positionen:':'Bitte um ein Angebot für folgende Positionen:')+'\n\n'
    +lines.join('\n')+'\n\n'
    +'Zwischensumme netto: '+fmt(cartSum())+'\n'
    +'zzgl. 19% MwSt.: '+fmt(cartSum()*MWST)+'\n'
    +'Gesamt: '+fmt(brutto(cartSum()))+'\n\n'
    +'Firma: '+agVal('agFirma')+'\n'
    +'Ansprechpartner: '+agVal('agName')+'\n'
    +'Adresse: '+agVal('agStreet')+', '+agVal('agCity')+'\n'
    +'E-Mail: '+agVal('agEmail')+'\n'
    +'Telefon: '+agVal('agPhone')
    +(agVal('agNote')?'\nAnmerkungen: '+agVal('agNote'):'');
  window.location.href='mailto:'+SELLER.mail+'?subject='+encodeURIComponent(subj)+'&body='+encodeURIComponent(body);
}

/* ---------- VIDEOS: auto path resolve + click to play ---------- */
(function(){
  const DIRS=[KEEY_CFG.filesBase];
  const EXTS=['.mp4'];
  const isVisible=v=>{
    if(!v.offsetParent) return false;
    const r=v.getBoundingClientRect();
    return r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth;
  };
  const playbackObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    const v=entry.target;
    if(entry.isIntersecting&&document.visibilityState==='visible') v.play().catch(()=>{});
    else v.pause();
  }),{threshold:.42});
  function loadVideo(v){
    if(v.dataset.loaded==='1') return;
    v.dataset.loaded='1';
    const name=v.dataset.name; if(!name) return;
    const card=v.closest('.video-card'), dot=card?card.querySelector('.play-dot'):null;
    const number=Number(name.split('-').pop());
    if(number<=4) v.setAttribute('poster',KA(name+'.jpg'));
    const cands=[]; DIRS.forEach(d=>EXTS.forEach(e=>cands.push(d+name+e)));
    let i=0, ok=false;
    v.addEventListener('loadeddata',()=>{ ok=true; if(isVisible(v))v.play().catch(()=>{}); if(dot)dot.textContent=v.paused?'▶':'❚❚'; },{once:true});
    function tryNext(){
      if(ok) return;
      if(i>=cands.length){ if(dot){ dot.textContent='⚠'; dot.title='Video nicht gefunden – bitte Dateinamen/Ordner prüfen'; } return; }
      v.src=cands[i++]; v.load();
    }
    v.addEventListener('error',tryNext);
    tryNext();
    function toggle(e){ if(e){e.preventDefault();e.stopPropagation();} if(v.paused){v.play().catch(()=>{});} else {v.pause();} if(dot)dot.textContent=v.paused?'▶':'❚❚'; }
    if(dot){ dot.style.cursor='pointer'; dot.addEventListener('click',toggle); }
    if(card) card.addEventListener('click',toggle);
    v.addEventListener('play',()=>{ if(dot)dot.textContent='❚❚'; });
    v.addEventListener('pause',()=>{ if(dot)dot.textContent='▶'; });
    playbackObserver.observe(v);
  }
  let railLoadObserver=null;
  window.toggleVideoLibrary=function(){
    const library=document.getElementById('videoLibrary');
    const button=document.getElementById('videoMoreBtn');
    const opening=library.hidden;
    library.hidden=!opening;
    button.setAttribute('aria-expanded',String(opening));
    button.querySelector('.label').textContent=opening?'Weniger Videos anzeigen':'Weitere Video-Einblicke ansehen';
    if(opening){
      const rail=document.getElementById('videoRail');
      if(!railLoadObserver){
        railLoadObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
          if(entry.isIntersecting){loadVideo(entry.target);railLoadObserver.unobserve(entry.target);}
        }),{root:rail,rootMargin:'0px 45% 0px 45%',threshold:.01});
        rail.querySelectorAll('video').forEach(v=>railLoadObserver.observe(v));
      }
      requestAnimationFrame(()=>library.scrollIntoView({behavior:'smooth',block:'nearest'}));
    }else{
      library.querySelectorAll('video').forEach(v=>v.pause());
    }
  };
  window.scrollVideoRail=function(direction){
    const rail=document.getElementById('videoRail');
    rail.scrollBy({left:direction*rail.clientWidth*.86,behavior:'smooth'});
  };
  function init(){
    const gridVideos=document.querySelectorAll('.video-grid .video-card video');
    const gridLoadObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){loadVideo(entry.target);gridLoadObserver.unobserve(entry.target);}
    }),{rootMargin:'500px 0px',threshold:.01});
    gridVideos.forEach(v=>gridLoadObserver.observe(v));
    const kick=()=>{ document.querySelectorAll('.video-card video[data-loaded="1"]').forEach(v=>{ if(v.paused&&isVisible(v)) v.play().catch(()=>{}); }); };
    window.addEventListener('touchstart',kick,{once:true,passive:true});
    window.addEventListener('click',kick,{once:true});
    document.addEventListener('visibilitychange',()=>{
      document.querySelectorAll('.video-card video[data-loaded="1"]').forEach(v=>document.hidden?v.pause():(isVisible(v)&&v.play().catch(()=>{})));
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();


/* ---------- TOAST ---------- */
let toastTimer;
function toast(msg){ const t=$('toast'); t.textContent=msg; t.classList.add('show'); clearTimeout(toastTimer); toastTimer=setTimeout(()=>t.classList.remove('show'),1900); }

/* ---------- PANEL VIEWS ---------- */
function goCart(){ $('viewCart').style.display='flex'; $('viewReview').style.display='none'; document.querySelector('#viewCart .items').scrollTop=0; }
function goReview(){ if(!cart.length){ toast('Dein Warenkorb ist leer'); return; } $('viewCart').style.display='none'; $('viewReview').style.display='flex'; }
function openPanel(){ if($('viewReview').style.display==='flex'&&!cart.length) goCart(); $('panel').classList.add('open'); $('panelBg').classList.add('open'); $('bar').classList.remove('show'); document.body.style.overflow='hidden'; }
function closePanel(){ $('panel').classList.remove('open'); $('panelBg').classList.remove('open'); document.body.style.overflow=''; updateCart(); }

/* ---------- REVEAL ---------- */

/* ---------- PRODUCT SHOWCASE ---------- */
const SC_IMGS={
  "crusty_strawberry":KA('inline-06-cae49722839c.webp'),
  "kufuku_sushi":KA('inline-07-f80bc244f285.webp'),
  "crusty_pizza":KA('inline-08-528a0c0a899a.webp'),
  "rasakopi_handle":KA('inline-09-f3bdbf1aeb41.webp'),
  "sushi_black":KA('inline-10-e1d40aad8651.webp'),
  "flower_bags":KA('inline-11-12c7eb31fe6e.webp'),
  "rasakopi_pink":KA('inline-12-4f9ffe25a768.webp')
};
Object.assign(SC_IMGS,{
  "inspiration_01":KA('inspiration-01-717198f120cf.webp'),"inspiration_02":KA('inspiration-02-3ed1e150d6e0.webp'),
  "inspiration_03":KA('inspiration-03-8db1b2fbcff7.webp'),"inspiration_04":KA('inspiration-04-1cf7f105cd3c.webp'),
  "inspiration_05":KA('inspiration-05-21cb86c772e4.webp'),"inspiration_06":KA('inspiration-06-d8eaffe49b40.webp'),
  "inspiration_07":KA('inspiration-07-79eaf0fa6731.webp'),"inspiration_08":KA('inspiration-08-109750594dfa.webp'),
  "inspiration_09":KA('inspiration-09-0df53a8bce56.webp'),"inspiration_10":KA('inspiration-10-65ae8abe71f1.webp'),
  "inspiration_11":KA('inspiration-11-ccc30aa30bad.webp'),"inspiration_12":KA('inspiration-12-585436fbb2a9.webp'),
  "inspiration_13":KA('inspiration-13-c485b743cb56.webp'),"inspiration_14":KA('inspiration-14-2e4dd98b0bde.webp'),
  "inspiration_15":KA('inspiration-15-0a6357a11763.webp'),"inspiration_16":KA('inspiration-16-18ccda5c56e6.webp'),
  "inspiration_17":KA('inspiration-17-f421dd8a7a15.webp'),"inspiration_18":KA('inspiration-18-3041866d5544.webp'),
  "inspiration_19":KA('inspiration-19-bb0113c6e7c8.webp'),"inspiration_20":KA('inspiration-20-d37e3a106a58.webp'),
  "inspiration_21":KA('inspiration-21-b944fe8db38b.webp'),"inspiration_22":KA('inspiration-22-9ce9136a0a73.webp'),
  "inspiration_23":KA('inspiration-23-cf35dec8b4d0.webp'),"inspiration_24":KA('inspiration-24-229b17889181.webp'),
  "inspiration_25":KA('inspiration-25-6c5bcae060ab.webp'),"inspiration_26":KA('inspiration-26-0af6b8a507f4.webp'),
  "inspiration_27":KA('inspiration-27-ed7754cdadbc.webp'),"inspiration_28":KA('inspiration-28-c887a42df308.webp')
});
const SC_BRAND={
  "crusty_strawberry":"Crusty Slices","kufuku_sushi":"Kufuku Sushi","crusty_pizza":"Crusty Slices",
  "rasakopi_handle":"Rasa Kopi","sushi_black":"Premium Sushi","flower_bags":"Bloom & Grace","rasakopi_pink":"Rasa Kopi",
  "inspiration_01":"Sandwich Box","inspiration_02":"Food Packaging","inspiration_03":"Pâtisserie Box","inspiration_04":"Retail Tragetasche",
  "inspiration_05":"Pizzakarton","inspiration_06":"Retail Tragetasche","inspiration_07":"Pâtisserie","inspiration_08":"Sushi Box",
  "inspiration_09":"Sushi Box","inspiration_10":"Retail Tragetasche","inspiration_11":"Retail Tragetasche","inspiration_12":"Premium Box",
  "inspiration_13":"Pâtisserie Box","inspiration_14":"Pâtisserie Box","inspiration_15":"Sandwich Box","inspiration_16":"Premium Box",
  "inspiration_17":"Coffee Cup","inspiration_18":"Pizzakarton","inspiration_19":"Döner Verpackung","inspiration_20":"Döner Box",
  "inspiration_21":"Feuchttücher","inspiration_22":"Food Box","inspiration_23":"Pizzakarton","inspiration_24":"Burger Box",
  "inspiration_25":"Gelato Palette","inspiration_26":"Kaffee-Dip-Set","inspiration_27":"Kaffee-Dip-Set","inspiration_28":"Kaffee & Donut Box"
};
/* Die beiden Reihen verwenden bewusst getrennte Bildmengen: kein Motiv läuft gleichzeitig oben und unten. */
const SC_A=["crusty_strawberry","crusty_pizza","sushi_black","rasakopi_pink","inspiration_01","inspiration_03","inspiration_05","inspiration_07","inspiration_09","inspiration_11","inspiration_13","inspiration_15","inspiration_17","inspiration_19","inspiration_21","inspiration_23","inspiration_25","inspiration_27"];
const SC_B=["kufuku_sushi","rasakopi_handle","flower_bags","inspiration_02","inspiration_04","inspiration_06","inspiration_08","inspiration_10","inspiration_12","inspiration_14","inspiration_16","inspiration_18","inspiration_20","inspiration_22","inspiration_24","inspiration_26","inspiration_28"];
function scCard(k,dup){const b=SC_BRAND[k];return '<div class="sc-card"'+(dup?' aria-hidden="true"':'')+'><img loading="lazy" decoding="async" fetchpriority="low" src="'+SC_IMGS[k]+'" alt="'+b+' – individuell bedruckte Verpackung von KEEY PACK"><span class="sc-tag">'+b+'</span></div>';}
function scBuild(id,order){const t=document.getElementById(id);if(!t)return;t.innerHTML=order.map(k=>scCard(k,false)).join('')+order.map(k=>scCard(k,true)).join('');}
scBuild('scTrackA',SC_A);scBuild('scTrackB',SC_B);

const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.15});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
document.addEventListener('keydown',e=>{if(e.key==='Escape'){if(document.getElementById('legalBg').classList.contains('open')){closeLegal();}else if(document.getElementById('angebotOverlay').classList.contains('open')){closeAngebot();}else{closeModal();closePanel();}}});

/* ---------- SHOP REVEAL ---------- */
let shopOpened=false;
function openShop(e){
  if(e) e.preventDefault();
  const inner=$('shopInner');
  if(!shopOpened){ inner.style.display='block'; inner.classList.add('shop-reveal'); shopOpened=true; }
  requestAnimationFrame(()=>{ $('shop').scrollIntoView({behavior:'smooth',block:'start'}); });
}
function openProduct(id){
  openShop();
  setTimeout(()=>openConfig(id),180);
}

/* Keep the configurator in its editorial desktop position, but bring it
   directly below the inspiration gallery on smaller screens. */
(function placeShopForViewport(){
  const shop=$('shop'), mobileSlot=$('mobileShopSlot'), desktopSlot=$('desktopShopSlot');
  if(!shop||!mobileSlot||!desktopSlot)return;
  const mq=window.matchMedia('(max-width:760px)');
  const place=()=>{
    const slot=mq.matches?mobileSlot:desktopSlot;
    if(slot.nextElementSibling!==shop)slot.insertAdjacentElement('afterend',shop);
  };
  place();
  if(mq.addEventListener)mq.addEventListener('change',place);
  else mq.addListener(place);
})();

buildChips();
renderFeatured();
renderGrid();
updateCart();

/* =====================================================================
   BÜROBEDARF – Sofort verfügbare Standardartikel zu Festpreisen.
   Quelle: shop.keey.de/collections/briefumschlage (Stand 06/2026).
   price = Verkaufspreis (brutto inkl. MwSt, wie im Shop angezeigt).
   was   = Regulärer Preis (optional, für Streichpreis). unit = Verkaufseinheit.
   ===================================================================== */
const CDN="https://shop.keey.de/cdn/shop/files/";
function B(o){return o;}
const BURO=[
 B({id:"b-etik-1",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 1 Etikett/Blatt, 210×297mm",cat:"Etiketten",price:9.99,was:13.90,img:CDN+"2CCBFAAB-7166-47BD-ADEE-5803E8EB5D0D.png?v=1732302274&width=700",img2:CDN+"BeigeBrownModernProductBenefitsYourStory-4.jpg?v=1714636046&width=700"}),
 B({id:"b-c6-120",name:"100 Briefumschläge C6 Kraftpapier 120g",cat:"Briefumschläge",price:10.90,was:14.90,img:CDN+"e1_dc8c8aea-3bee-42a0-a4b7-db206f360a49.png?v=1714634038&width=700",img2:CDN+"e2_cc04fd90-9f9b-4c65-a1bb-bdcd5cd289bf.png?v=1714634040&width=700"}),
 B({id:"b-c6-kraft",name:"100 Briefumschläge C6 Kraftpapier",cat:"Briefumschläge",price:8.90,was:12.90,soldout:true,img:CDN+"e1_dc8c8aea-3bee-42a0-a4b7-db206f360a49.png?v=1714634038&width=700",img2:CDN+"e2_cc04fd90-9f9b-4c65-a1bb-bdcd5cd289bf.png?v=1714634040&width=700"}),
 B({id:"b-etik-14",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 14/Blatt, 105×42mm",cat:"Etiketten",price:9.99,was:14.99,img:CDN+"E97305D7-5740-415E-8908-0257FEC593B3.png?v=1732302318&width=700",img2:CDN+"Beige_Brown_Modern_Product_Benefits_Your_Story-10.jpg?v=1720432825&width=700"}),
 B({id:"b-c4-fenster",name:"250 Briefumschläge C4 – 90g – MIT Fenster",cat:"Briefumschläge",price:10.90,was:17.90,img:CDN+"e1_ea737ab0-070e-4921-a5f7-700d1a1980c3.png?v=1714633902&width=700",img2:CDN+"e2_dfd7037f-d9f9-4e18-a795-2758871b371c.png?v=1714633903&width=700"}),
 B({id:"b-etik-8",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 8/Blatt, 105×70mm",cat:"Etiketten",price:9.99,img:CDN+"8.png?v=1732721324&width=700",img2:CDN+"51DZXjYFmEL._AC_SL1080_-2_7fb1d0e4-8895-4583-97db-55f9586917e1.jpg?v=1714641137&width=700"}),
 B({id:"b-etik-24",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 24/Blatt, 70×37mm",cat:"Etiketten",price:9.99,was:14.90,img:CDN+"24.png?v=1732721220&width=700",img2:CDN+"51DZXjYFmEL._AC_SL1080_-2_1ead94a9-9df3-48ab-842d-1ae16726f480.jpg?v=1714636046&width=700"}),
 B({id:"b-thermo",name:"Thermo-Etiketten 100×150mm selbstklebend – 500 Stk/Rolle, weiß",cat:"Etiketten",price:13.90,img:CDN+"width-550.webp?v=1736860475&width=700",img2:CDN+"61ei4ktaDuL._AC_SL1500.jpg?v=1736860507&width=700"}),
 B({id:"b-c6-1000",name:"1000 Briefumschläge C6 – OHNE Fenster",cat:"Briefumschläge",price:14.90,was:24.90,soldout:true,img:CDN+"envelope1.png?v=1714634352&width=700",img2:CDN+"envelope2.png?v=1714634352&width=700"}),
 B({id:"b-papier-500",name:"Druckerpapier DIN A4, 80 g/m², 500 Blatt, weiß",cat:"Papier",price:4.90,was:5.90,img:CDN+"58720CBB-27A2-447E-B460-95E5A33E7AAB.png?v=1750851086&width=700"}),
 B({id:"b-etik-65",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 65/Blatt, 38×61mm",cat:"Etiketten",price:9.99,img:CDN+"64.png?v=1732721294&width=700",img2:CDN+"51DZXjYFmEL._AC_SL1080_-2_9bef961a-7f1d-4742-a3ff-0aec2d1ce2bf.jpg?v=1714642248&width=700"}),
 B({id:"b-etik-4",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 4/Blatt, 105×148mm",cat:"Etiketten",price:9.99,img:CDN+"4.png?v=1732721261&width=700",img2:CDN+"51DZXjYFmEL._AC_SL1080_-2_c475660b-72f6-4d1c-8308-f2c2b38a3cfb.jpg?v=1714637194&width=700"}),
 B({id:"b-etik-2",name:"Selbstklebende Etiketten – 100 Blatt DIN A4, 2/Blatt, 210×148mm",cat:"Etiketten",price:9.99,img:CDN+"2-3.png?v=1732721157&width=700",img2:CDN+"51DZXjYFmEL._AC_SL1080_-2.jpg?v=1714635855&width=700"}),
 B({id:"b-papier-2500",name:"Druckerpapier DIN A4, 80 g/m², 2500 Blatt (5×500), weiß",cat:"Papier",price:19.90,was:26.90,img:CDN+"8435B602-9842-4053-B029-197C877D2885.png?v=1750851086&width=700",img2:CDN+"77CC26F1-F121-4C1C-86A1-492A21E65179.png?v=1750851086&width=700"}),
 B({id:"b-dl-100-of",name:"100 Briefumschläge DIN Lang 110×220 – 80g – OHNE Fenster",cat:"Briefumschläge",price:8.49,soldout:true,img:CDN+"e1_b4e6a1af-74b7-45e2-acf9-b80c5527dba4.png?v=1714633762&width=700",img2:CDN+"e2_4061c666-b39e-4892-be6f-3d33884e2538.png?v=1714633763&width=700"}),
 B({id:"b-dl-1000-of",name:"1000 Briefumschläge DIN Lang 110×220 – 80g – OHNE Fenster",cat:"Briefumschläge",price:29.49,img:CDN+"e1_3ef2e3ab-8c4d-4e4d-9ea6-795a0bb3a023.png?v=1714633655&width=700",img2:CDN+"e3_ebec6be4-2e96-4228-b910-421ef7719ab8.png?v=1714633655&width=700"}),
 B({id:"b-dl-100-mf",name:"100 Briefumschläge DIN Lang 110×220 – 80g – MIT Fenster",cat:"Briefumschläge",price:7.99,was:9.90,img:CDN+"e1_c643807c-26e7-4e6e-9901-dd22ce323f92.png?v=1714631195&width=700",img2:CDN+"e2_0263664b-3693-4b15-a3d8-332a2dc154fd.png?v=1714631195&width=700"}),
 B({id:"b-dl-1000-mf",name:"1000 Briefumschläge DIN Lang 110×220 – 80g – MIT Fenster",cat:"Briefumschläge",price:19.90,was:24.90,img:CDN+"e1.png?v=1714630898&width=700",img2:CDN+"e2.png?v=1714630900&width=700"})
];
BURO.forEach(p=>{
  const live=KEEY_CFG.buero&&KEEY_CFG.buero[p.id];
  if(!live) return;
  if(live.price) p.price=live.price;
  p.was = live.was || null;
  p.soldout = !live.avail || !live.id;
  p.variantId = live.id;
});
const BURO_CATS=["Alle","Briefumschläge","Etiketten","Papier"];
let bCat="Alle";

// Preise im Shop sind brutto -> netto für den Warenkorb (passt zur MwSt-Logik)
const netFromGross=g=>g/(1+MWST);

function buildBChips(){
  bCatRow.innerHTML=BURO_CATS.map(c=>`<button class="chip${c===bCat?' on':''}" onclick="setBCat('${c}')">${c}</button>`).join("");
}
function setBCat(c){bCat=c;buildBChips();renderBuero();}
function renderBuero(){
  const list=BURO.filter(p=>bCat==="Alle"||p.cat===bCat);
  bGrid.innerHTML=list.map(p=>{
    const inCart=cart.some(c=>c.id===p.id);
    const pct=p.was?Math.round((1-p.price/p.was)*100):0;
    return `<div class="bcard${inCart?' added':''}" id="bc-${p.id}">
      <div class="imgwrap"><div class="bimg-stack">
        <img class="bimg-main" loading="lazy" src="${p.img}" alt="${p.name}">
        ${p.img2?`<img class="bimg-hover" loading="lazy" src="${p.img2}" alt="${p.name} – Detailansicht">`:""}
      </div>
        <div class="bactions">
          <button title="In den Warenkorb" onclick="addBuro('${p.id}')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></button>
          <button class="fav" title="Merken" onclick="bueroFav(this)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8Z"/></svg></button>
          <button title="Vergleichen" onclick="toast('Vergleichen – bald verfügbar')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3h5v5"/><path d="M21 3 13 11"/><path d="M8 21H3v-5"/><path d="M3 21l8-8"/></svg></button>
          <button title="Schnellansicht" onclick="bueroQuick('${p.id}')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg></button>
        </div>
      </div>
      <div class="body">
        <span class="cat">${p.cat}</span>
        <h3>${p.name}</h3>
        <div class="prc">
          <span class="now">${fmt(p.price)}</span>
          ${p.was?`<span class="was">${fmt(p.was)}</span><span class="pct">-${pct}%</span>`:""}
        </div>
        <div class="mwst">inkl. MwSt · ${fmt(netFromGross(p.price))} netto</div>
        ${p.soldout
          ? `<div class="addb soldout">Ausverkauft</div>`
          : `<button class="addb" onclick="addBuro('${p.id}')">${inCart?'✓ Im Warenkorb':'In den Warenkorb'}</button>`}
      </div></div>`;
  }).join("");
}
function addBuro(id){
  const p=BURO.find(x=>x.id===id);if(!p)return;
  if(p.soldout){toast("Leider ausverkauft");return;}
  const net=netFromGross(p.price);
  cart.push({
    uid:Date.now()+"-"+Math.random().toString(36).slice(2,6),
    id:p.id,name:p.name,cat:p.cat,img:p.img,
    size:"Standard",sizeIdx:0,mat:"",
    qty:1,colors:1,price:net,unit:net,fixed:true,shopifyVariantId:p.variantId||null
  });
  updateCart();renderBuero();openPanel();
  toast("Zum Warenkorb hinzugefügt");
}
/* Hover-Aktionen: Merken (lokaler Toggle) + Schnellansicht */
function bueroFav(btn){btn.classList.toggle('on');}
function bueroQuick(id){
  const p=BURO.find(x=>x.id===id);if(!p)return;
  const pct=p.was?Math.round((1-p.price/p.was)*100):0;
  let ov=document.getElementById('bQuick');
  if(!ov){
    ov=document.createElement('div');ov.id='bQuick';ov.className='bq-ov';
    ov.addEventListener('click',e=>{if(e.target===ov||e.target.classList.contains('bq-x'))ov.classList.remove('open');});
    document.body.appendChild(ov);
    document.addEventListener('keydown',e=>{if(e.key==='Escape')ov.classList.remove('open');});
  }
  ov.innerHTML=`<div class="bq-card">
    <button class="bq-x" aria-label="Schließen">×</button>
    <div class="bq-img"><img src="${p.img}" alt="${p.name}"></div>
    <div class="bq-body">
      <span class="cat">${p.cat}</span>
      <h3>${p.name}</h3>
      ${p.teaser?`<p class="bq-teaser">${p.teaser}</p>`:""}
      <div class="prc"><span class="now">${fmt(p.price)}</span>${p.was?`<span class="was">${fmt(p.was)}</span><span class="pct">-${pct}%</span>`:""}</div>
      <div class="mwst">inkl. MwSt · ${fmt(netFromGross(p.price))} netto</div>
      ${p.soldout?`<div class="addb soldout">Ausverkauft</div>`:`<button class="addb" onclick="addBuro('${p.id}');document.getElementById('bQuick').classList.remove('open')">In den Warenkorb</button>`}
    </div></div>`;
  ov.classList.add('open');
}

/* ---------- RECHTLICHES (In-Page Modal) ----------
   Impressum: echte Pflichtangaben der KEEY GmbH.
   AGB / Widerruf / Datenschutz: Kurzfassung + Link zur amtlichen Vollversion. */
const LEGAL={
  impressum:{title:"Impressum",html:`
<p class="lrow"><b>KEEY GmbH</b><br>Bräuersdorf 28<br>91469 Hagenbüchach</p>
<p class="lrow">Geschäftsführer: Timur Sakanci</p>
<p class="lrow">Telefon: +49 911 47778350<br>E-Mail: <a href="mailto:info@keey.de">info@keey.de</a></p>
<h3>Registereintrag</h3>
<p>Eintragung im Handelsregister.<br>Registergericht: Amtsgericht Fürth<br>Registernummer: HRB 733407</p>
<h3>Umsatzsteuer-ID</h3>
<p>Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:<br>DE326760672</p>
<h3>Haftungsausschluss</h3>
<p><b>Haftung für Inhalte</b><br>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
<p><b>Haftung für Links</b><br>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
<p><b>Urheberrecht</b><br>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
<p><b>Datenschutz</b><br>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.</p>
<div class="official">Amtliche Fassung: <a href="/pages/impressum" target="_blank" rel="noopener">keey.de/pages/impressum</a></div>`},
  agb:{title:"Allgemeine Geschäfts- und Nutzungsbedingungen",html:`
<p><b>Allgemeine Geschäfts- und Nutzungsbedingungen</b></p>
<h3>I. Nutzungs- und Geschäftsbedingungen für den Geschäftsbereich „Internet"</h3>
<p>Bitte haben Sie Verständnis dafür, dass wir aufgrund der vielfältigen Möglichkeiten und Risiken, die das Internet bietet, zu Ihrem und unserem Schutz einige Rahmenbedingungen zur Nutzung unserer Website aufstellen müssen, die wir Sie bitten, zu beachten.</p>
<p>Die vorliegenden Bedingungen beziehen sich auf alle Dienstleistungen der KEEY GmbH und auf folgende Webseiten/Domains: www.keey.de</p>
<p>Die Firma Keey GmbH bietet Ihnen über ihre Portale und Dienste den Zugriff auf aktuelle Meldungen und Artikel und Fachbeiträge sowie auf zahlreiche weitere Angebote. Diese Leistungen sind für Sie kostenlos.</p>
<p><b>§1 Urheber- und Kennzeichenrechte</b></p>
<p>1) Bitte beachten Sie, dass die auf den Portalen der Keey GmbH veröffentlichten Schriftwerke, Fotografien und Illustrationen, Videos und sonstige Inhalte dem Schutz des deutschen Urheberrechts unterliegen und von Ihnen nur dann vervielfältigt oder anderweitig genutzt werden dürfen, wenn Ihnen dies im Einzelfall durch den Rechteinhaber oder die gesetzlichen Schranken des Urheberrechts gestattet ist. Diese Inhalte unterliegen keiner Creative Common Lizenz, es sei denn, eine solche ist ausdrücklich angegeben. Eine Verlinkung oder Zitierung ist ohne Genehmigung zulässig, soweit dies in den Grenzen des urheberrechtlichen Zitatrechts nach § 51 UrhG erfolgt.</p>
<p>2) Bitte beachten Sie auch, dass die Kennzeichen (Marken, Geschäftsbezeichnungen, Zeitschriften- und Rubrikentitel) der Keey GmbH dem Schutz des Markengesetzes unterliegen.</p>
<p><b>§2 Haftung der Keey GmbH</b></p>
<p>1) Die Keey GmbH übernimmt keine rechtliche Gewähr für die Richtigkeit, Vollständigkeit oder Aktualität von redaktionellen Beiträgen. Inhalte Dritter können von der KEEY GmbH grundsätzlich nicht auf ihre Richtigkeit und Rechtmäßigkeit hin überprüft werden und die KEEY GmbH macht sich entsprechende Einträge nicht zu Eigen. Sollten Sie rechtsverletzende Einträge Dritter feststellen, so wenden Sie sich bitte an: info@keey.de</p>
<p>2) Die KEEY GmbH wird sich bemühen, Ihre Dienste stets zugänglich zu halten, sie übernimmt hierfür jedoch keine Haftung. Ein Anspruch auf ständige Verfügbarkeit besteht nicht. Die KEEY GmbH behält sich vor, ihr Angebot oder Teile des Angebots jederzeit zu beenden oder einzuschränken. Für kostenpflichtige Angebote gelten jeweils ergänzende Bestimmungen.</p>
<p>3) Eine Haftung für einen Datenverlust des Nutzers oder Schäden an Hard- oder Software des Nutzers übernimmt die KEEY GmbH nur für den Fall des Vorsatzes oder der groben Fahrlässigkeit oder der Verletzung von Kardinalpflichten. Die Haftung ist begrenzt auf denjenigen Schaden, welcher bei vertragsgemäßer privater Nutzung durch den Nutzer vernünftigerweise vorhersehbar ist.</p>
<p><b>§3 Registrierung</b></p>
<p>1) Die Nutzung der Leserartikel- und Kommentarfunktion von KEEY GmbH setzt voraus, dass Sie sich unter Angabe Ihrer E-Mail-Adresse, eines frei wählbaren Benutzernamens und eines frei wählbaren persönlichen Passwortes als Nutzer registrieren. Sie können Ihr Passwort später beliebig ändern. Die KEEY GmbH sendet Ihnen eine Bestätigung der Registrierung mit einem Aktivierungslink per E-Mail zu. Erst nach Anklicken dieses Links ist die Registrierung abgeschlossen.</p>
<p>2) Sie sind verpflichtet, der KEEY GmbH relevante Änderungen Ihrer Angaben unverzüglich mitzuteilen. Nur so können wir vermeiden, dass Ihre Daten von anonymen Dritten missbräuchlich verwendet werden. Sie dürfen Ihr Passwort keinem Dritten offenlegen oder anderweitig einen Missbrauch durch Dritte ermöglichen. Sollten Sie Anlass zu der Annahme haben, dass Ihr Passwort Dritten offenbar geworden sein könnte, so teilen Sie dies der KEEY GmbH unverzüglich mit.</p>
<p>3) Sie verpflichten sich, die registrierungspflichtigen Dienste von KEEY GmbH nicht zu geschäftlichen, gewerblichen oder sonstigen kommerziellen Zwecken oder Versendung unerwünschter Werbung zu nutzen. Es ist Ihnen ferner untersagt, in Ihrem Benutzerprofil Inhalte oder Abbildungen einzustellen, die die Rechte Dritter verletzen und/oder gegen geltendes Zivil- oder Strafrecht verstoßen. Der Nutzer hält die KEEY GmbH und ihre Mitarbeiter von Ansprüchen Dritter einschließlich der Kosten der Rechtsverteidigung frei, die auf eine solche Rechtsverletzung gestützt werden sollten. Sie verpflichten sich, keine Daten zu übermitteln, die Viren, Trojaner oder sonstige Daten bzw. Programme enthalten, die geeignet sind, Schäden an Hard- oder Software der KEEY GmbH oder jener Dritter herbeizuführen.</p>
<p>4) Das Vertragsverhältnis zwischen Ihnen und der KEEY GmbH wird auf unbestimmte Zeit geschlossen und ist von beiden Parteien jederzeit fristlos kündbar. Die Kündigung des Nutzers muss schriftlich oder in Textform (Erklärung per E-Mail an: info@keey.de, Brief oder Faxschreiben) erfolgen. Im Falle der dauerhaften Einstellung eines registrierungspflichtigen Dienstes gilt der Vertrag auch ohne gesonderte Kündigungserklärung als beendet.</p>
<h3>II. Nutzungs- und Geschäftsbedingungen für den Geschäftsbereich „Druckerei"</h3>
<p><b>§1 Geltungsbereich/Vertragsabschluss</b></p>
<p>Aufträge werden ausschließlich auf der Grundlage nachfolgender Bedingungen ausgeführt. Abweichende Regelungen bedürfen der schriftlichen Bestätigung.</p>
<p><b>§2 Preise</b></p>
<p>1) Die im Angebot des Auftragnehmers genannten Preise gelten unter dem Vorbehalt, dass die der Angebotsabgabe zugrunde gelegten Auftragsdaten unverändert bleiben, längstens jedoch zwei Monate nach Eingang des Angebots beim Auftraggeber. Bei Aufträgen mit Lieferung an Dritte gilt der Besteller als Auftraggeber, soweit keine anderweitige ausdrückliche Vereinbarung getroffen wurde. Die Preise des Auftragnehmers gelten ab Werk. Sie schließen Verpackung, Fracht, Porto, Versicherung und sonstige Versandkosten nicht ein.</p>
<p>2) Nachträgliche Änderungen auf Veranlassung des Auftraggebers einschließlich des dadurch verursachten Maschinenstillstands werden dem Auftraggeber berechnet. Als nachträgliche Änderungen gelten auch Wiederholungen von Probeandrucken, die vom Auftraggeber wegen geringfügiger Abweichung von der Vorlage verlangt werden.</p>
<p>3) Skizzen, Entwürfe, Probesatz, Probedrucke, Korrekturabzüge, Änderung angelieferter/übertragener Daten und ähnliche Vorarbeiten, die vom Auftraggeber veranlasst sind, werden gesondert berechnet.</p>
<p>4) Bei Bereitstellung außergewöhnlich großer Mengen an Material oder Vorleistungen sowie bei bereits aufgetretenem Zahlungsverzug können Vorauszahlungen verlangt werden.</p>
<p>5) Alle vom Auftragnehmer in Rechnung gestellten Preise und Nebenkosten erhöhen sich stets um die Mehrwertsteuer in der jeweils gesetzlich geltenden Höhe.</p>
<p><b>§3 Zahlungen</b></p>
<p>1) Rechnungen sind spätestens innerhalb 30 Kalendertagen nach Rechnungsdatum zu bezahlen. Die Rechnung wird unter dem Tag der Lieferung, Teillieferung oder Lieferbereitschaft (Holschuld, Annahmeverzug) ausgestellt.</p>
<p>2) Der Auftraggeber kann nur mit einer unbestrittenen oder rechtskräftig festgestellten Forderung aufrechnen oder ein Zurückbehaltungsrecht ausüben.</p>
<p>3) Wird nach Vertragsabschluss erkennbar, dass die Erfüllung des Zahlungsanspruchs durch die mangelnde Leistungsfähigkeit des Auftraggebers gefährdet wird, so kann der Auftragnehmer Vorauszahlung verlangen, noch nicht ausgelieferte Ware zurückhalten sowie die Weiterarbeit einstellen. Diese Rechte stehen dem Auftragnehmer auch zu, wenn der Auftraggeber sich mit der Bezahlung von Lieferungen in Verzug befindet, die auf demselben rechtlichen Verhältnis beruhen. § 321 II BGB bleibt unberührt.</p>
<p>4) Bei Zahlungsverzug sind sofortige Verzugszinsen in Höhe von 5 % über dem Basiszinssatz zu zahlen. Die Geltendmachung weiteren Verzugsschadens wird hierdurch nicht ausgeschlossen. Zahlt der Auftraggeber binnen 30 Kalendertagen nach Rechnungserhalt und Lieferung der Ware den Preis einschließlich der Nebenkosten gem. Ziff. II („Preise") nicht, kommt er auch ohne Mahnung in Verzug.</p>
<p><b>§4 Lieferung</b></p>
<p>1) Die Lieferung erfolgt ab Fürth (Geschäftsräume des Auftragnehmers). Soll die Ware versendet werden, geht die Gefahr auf den Auftraggeber über, sobald die Sendung an die den Transport durchführende Person übergeben worden ist.</p>
<p>2) Liefertermine sind nur gültig, wenn sie vom Auftragnehmer ausdrücklich bestätigt werden. Wird der Vertrag schriftlich abgeschlossen, bedarf auch die Bestätigung über den Liefertermin der Schriftform.</p>
<p>3) Verzögert der Auftragnehmer die Leistung, so kann der Auftraggeber die Rechte aus § 323 BGB nur ausüben, wenn die Verzögerung vom Auftragnehmer zu vertreten ist. Eine Änderung der Beweislast ist mit dieser Regelung nicht verbunden. Betriebsstörungen – sowohl im Betrieb des Auftragnehmers als auch in dem eines Zulieferers – wie z. B. Streik, Aussperrung sowie alle sonstigen Fälle höherer Gewalt, berechtigen erst dann zur Kündigung des Vertrags, wenn dem Auftraggeber ein weiteres Abwarten nicht mehr zugemutet werden kann, anderenfalls verlängert sich die vereinbarte Lieferfrist um die Dauer der Verzögerung. Eine Kündigung ist jedoch frühestens vier Wochen nach Eintritt der oben beschriebenen Betriebsstörung möglich. Eine Haftung des Auftragnehmers ist in diesen Fällen ausgeschlossen.</p>
<p>4) Bis zur vollständigen Bezahlung aller fälligen Forderungen aus der Geschäftsverbindung steht dem Auftragnehmer ein Zurückbehaltungsrecht gemäß § 369 HGB an vom Auftraggeber beigestellten Daten, Manuskripten, Rohmaterialien oder sonstigen Gegenständen zu.</p>
<p>5) Der Auftragnehmer nimmt im Rahmen der ihm aufgrund der Verpackungsverordnung obliegenden Pflichten Verpackungen zurück. Der Auftraggeber kann Verpackungen im Betrieb des Auftragnehmers zu den üblichen Geschäftszeiten nach rechtzeitiger vorheriger Anmeldung zurückgeben, es sei denn, ihm ist eine andere Annahme-/Sammelstelle benannt worden. Die Verpackungen können dem Auftragnehmer auch bei der Lieferung zurückgegeben werden, es sei denn, dem Auftraggeber ist eine andere Annahme-/Sammelstelle benannt worden. Zurückgenommen werden Verpackungen nur unmittelbar nach Auslieferung der Ware, bei Folgelieferungen nur nach rechtzeitiger vorheriger Mitteilung und Bereitstellung. Die Kosten des Transports der gebrauchten Verpackungen trägt der Auftraggeber. Ist eine benannte Annahme-/Sammelstelle weiter entfernt als der Betrieb des Auftragnehmers, so trägt der Auftraggeber lediglich die Transportkosten, die für eine Entfernung bis zum Betrieb des Auftragnehmers entstehen würden. Die zurückgegebenen Verpackungen müssen sauber, frei von Fremdstoffen und nach unterschiedlicher Verpackung sortiert sein. Anderenfalls ist der Auftragnehmer berechtigt, vom Auftraggeber die bei der Entsorgung entstehenden Mehrkosten zu verlangen.</p>
<p><b>§5 Eigentumsvorbehalt</b></p>
<p>1) Die gelieferte Ware bleibt bis zur vollständigen Bezahlung aller zum Rechnungsdatum bestehenden Forderungen des Auftragnehmers gegen den Auftraggeber sein Eigentum. Zur Weiterveräußerung ist der Auftraggeber nur im ordnungsgemäßen Geschäftsgang berechtigt. Der Auftraggeber tritt seine Forderungen aus der Weiterveräußerung hierdurch an den Auftragnehmer ab. Der Auftragnehmer nimmt die Abtretung hiermit an. Spätestens im Falle des Verzugs ist der Auftraggeber verpflichtet den Schuldner der abgetretenen Forderung zu nennen. Übersteigt der Wert der für den Auftragnehmer bestehenden Sicherheiten dessen Forderung insgesamt um mehr als 20 %, so ist der Auftragnehmer auf Verlangen des Auftraggebers oder eines durch die Übersicherung des Auftragnehmers beeinträchtigten Dritten insoweit zur Freigabe von Sicherungen nach Wahl des Auftragnehmers verpflichtet.</p>
<p>2) Bei Be- oder Verarbeitung vom Auftragnehmer gelieferter und in dessen Eigentum stehender Waren ist der Auftragnehmer als Hersteller gemäß § 950 BGB anzusehen und behält in jedem Zeitpunkt der Verarbeitung Eigentum an den Erzeugnissen. Sind Dritte an der Be- oder Verarbeitung beteiligt, ist der Auftragnehmer auf einen Miteigentumsanteil in Höhe des Rechnungswerts der Vorbehaltsware beschränkt. Das so erworbene Eigentum gilt als Vorbehaltseigentum.</p>
<p>3) Die vom Auftragnehmer zur Herstellung seines Erzeugnisses eingesetzten Betriebsgegenstände, insbesondere Daten, Druckplatten bleiben, auch wenn sie gesondert berechnet werden, sein Eigentum und werden nicht mitgeliefert.</p>
<p><b>§6 Beanstandungen/Gewährleistungen</b></p>
<p>1) Der Auftraggeber hat die Vertragsgemäßheit der Ware sowie der zur Korrektur übersandten Vor- und Zwischenerzeugnisse in jedem Fall unverzüglich zu prüfen. Die Gefahr etwaiger Fehler geht mit der Druckreiferklärung / Fertigungsreiferklärung auf den Auftraggeber über, soweit es sich nicht um Fehler handelt, die erst in dem sich an die Druckreiferklärung/Fertigungsreiferklärung anschließenden Fertigungsvorgang entstanden sind oder erkannt werden konnten. Das gleiche gilt für alle sonstigen Freigabeerklärungen des Auftraggebers.</p>
<p>2) Offensichtliche Mängel sind innerhalb einer Frist von einer Woche ab Empfang der Ware schriftlich anzuzeigen, versteckte Mängel innerhalb einer Frist von einer Woche ab Entdeckung; andernfalls ist die Geltendmachung des Gewährleistungsanspruchs ausgeschlossen.</p>
<p>3) Bei berechtigten Beanstandungen ist der Auftragnehmer zunächst nach seiner Wahl zur Nachbesserung und/oder Ersatzlieferung verpflichtet und berechtigt. Kommt der Auftragnehmer dieser Verpflichtung nicht innerhalb einer angemessenen Frist nach oder schlägt die Nachbesserung trotz wiederholten Versuchs fehl, kann der Auftraggeber Herabsetzung der Vergütung (Minderung) oder Rückgängigmachung des Vertrags (Rücktritt) verlangen.</p>
<p>4) Mängel eines Teils der gelieferten Ware berechtigen nicht zur Beanstandung der gesamten Lieferung, es sei denn, dass die Teillieferung für den Auftraggeber ohne Interesse ist.</p>
<p>5) Bei farbigen Reproduktionen in allen Herstellungsverfahren können geringfügige Abweichungen vom Original nicht beanstandet werden. Das gleiche gilt für den Vergleich zwischen sonstigen Vorlagen (z. B. Digital Proofs, Andrucken) und dem Endprodukt. Darüber hinaus ist die Haftung für Mängel, die den Wert oder die Gebrauchstauglichkeit nicht oder nur unwesentlich beeinträchtigen, ausgeschlossen.</p>
<p>6) Für Abweichungen in der Beschaffenheit des eingesetzten Materials haftet der Auftragnehmer nur bis zur Höhe des Auftragswerts.</p>
<p>7) Zulieferungen (auch Datenträger, übertragene Daten) durch den Auftraggeber oder durch einen von ihm eingeschalteten Dritten unterliegen keiner Prüfungspflicht seitens des Auftragnehmers. Dies gilt nicht für offensichtlich nicht verarbeitungsfähige oder nicht lesbare Daten.</p>
<p>8) Bei Datenübertragungen sind alle datenschutzrelevanten Vorschriften und Gesetze zu beachten, insbesondere das Bundesdatenschutzgesetz (BDSG). Zusätzlich hat der Auftraggeber vor Übersendung jeweils dem neuesten technischen Stand entsprechende Schutzprogramme für Computerviren einzusetzen. Die Datensicherung obliegt allein dem Auftraggeber. Der Auftragnehmer ist berechtigt eine Kopie anzufertigen.</p>
<p>9) Mehr- oder Minderlieferungen bis zu 10 % der bestellten Auflage können nicht beanstandet werden. Berechnet wird die gelieferte Menge. Bei Lieferungen aus Papiersonderanfertigungen unter 1.000 kg erhöht sich der Prozentsatz auf 20 %, unter 2.000 kg auf 15 %.</p>
<p><b>§7 Haftung</b></p>
<p>1) Schadens- und Aufwendungsersatzansprüche des Auftraggebers, gleich aus welchem Rechtsgrund, sind ausgeschlossen. Dieser Haftungsausschluss gilt nicht bei vorsätzlich oder grobfahrlässig verursachtem Schaden, bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten, auch durch gesetzliche Vertreter oder Erfüllungsgehilfen des Auftragnehmers; insoweit haftet er nur auf den nach Art des Produkts vorhersehbaren, vertragstypischen, unmittelbaren Durchschnittsschaden, im Falle schuldhafter Verletzung des Lebens, des Körpers oder der Gesundheit des Auftraggebers, bei arglistig verschwiegenen Mängeln und übernommener Garantie für die Beschaffenheit der Ware, bei Ansprüchen aus dem Produkthaftungsgesetz.</p>
<p><b>§8 Verjährung</b></p>
<p>2) Ansprüche des Auftraggebers auf Gewährleistung und Schadensersatz (Ziffern VI. und VII.) verjähren mit Ausnahme der unter Ziffer VII. 2. genannten Schadensersatzansprüche in einem Jahr beginnend mit der (Ab-)Lieferung der Ware. Dies gilt nicht, soweit der Auftragnehmer arglistig gehandelt hat.</p>
<p><b>§9 Handelsbrauch</b></p>
<p>3) Im kaufmännischen Verkehr gelten die Handelsbräuche der Druckindustrie (z. B. keine Herausgabepflicht von Zwischenerzeugnissen wie Daten, Lithos oder Druckplatten, die zur Herstellung des geschuldeten Endprodukts erstellt werden), sofern kein abweichender Auftrag erteilt wurde.</p>
<p><b>§10 Archivierung</b></p>
<p>1) Dem Auftraggeber zustehende Produkte, insbesondere Daten und Datenträger, werden vom Auftragnehmer nur nach ausdrücklicher Vereinbarung und gegen besondere Vergütung über den Zeitpunkt der Übergabe des Endprodukts an den Auftraggeber oder seine Erfüllungsgehilfen hinaus archiviert. Sollen die vorbezeichneten Gegenstände versichert werden, so hat dies bei fehlender Vereinbarung der Auftraggeber selbst zu besorgen.</p>
<p><b>§11 Periodische Arbeiten</b></p>
<p>1) Verträge über regelmäßig wiederkehrende Arbeiten können mit einer Frist von mindestens 3 Monaten zum Schluss eines Monats gekündigt werden.</p>
<p><b>§12 Gewerbliche Schutzrechte/Urheberrecht</b></p>
<p>1) Der Auftraggeber haftet allein, wenn durch die Ausführung seines Auftrags Rechte Dritter, insbesondere Urheberrechte verletzt werden. Der Auftraggeber hat den Auftragnehmer von allen Ansprüchen Dritter wegen einer solchen Rechtsverletzung freizustellen.</p>
<p><b>§13 Erfüllungsort, Gerichtsstand, Wirksamkeit</b></p>
<p>1) Erfüllungsort und Gerichtsstand sind ausschließlich, soweit gesetzlich zulässig, Nürnberg. Auf das Vertragsverhältnis findet deutsches Recht Anwendung. UN-Kaufrecht ist ausgeschlossen.</p>
<p>2) Durch etwaige Unwirksamkeit einer oder mehrerer Bestimmungen wird die Wirksamkeit der übrigen Bestimmungen nicht berührt.</p>
<p><i>Fürth, 15.04.2021</i></p>
<div class="official">Amtliche Fassung: <a href="/pages/agb" target="_blank" rel="noopener">keey.de/pages/agb</a></div>`},
  widerruf:{title:"Widerrufsrecht",html:`
<p>Wir gewähren ein 30-tägiges Rückgaberecht. Das bedeutet, dass du nach Erhalt deines Artikels 30 Tage Zeit hast, um eine Rückgabe anzufordern.</p>
<p>Um für eine Rückgabe berechtigt zu sein, muss sich der Artikel in demselben Zustand befinden, in dem du ihn erhalten hast, ungetragen, ungenutzt und mit Etiketten versehen sein und sich in der Originalverpackung befinden. Außerdem benötigst du den Beleg oder einen anderen Kaufnachweis.</p>
<p>Um eine Rückgabe einzuleiten, kannst du uns unter <a href="mailto:info@keey.de">info@keey.de</a> kontaktieren. Bitte beachte, dass Rückgaben an die folgende Adresse gesendet werden müssen: KEEY GmbH, Bräuersdorf 28, 91469 Hagenbüchach.</p>
<p>Wenn deine Rückgabe akzeptiert wird, erhältst du von uns ein Rücksendeetikett sowie Anweisungen, wie und wohin du das Paket versenden sollst. Artikel, die an uns zurückgesendet werden, ohne dass zuvor eine Rückgabe angefordert wurde, werden nicht akzeptiert.</p>
<p>Bei Fragen zur Rückgabe kannst du uns jederzeit unter <a href="mailto:info@keey.de">info@keey.de</a> kontaktieren.</p>
<h3>Schäden und Probleme</h3>
<p>Bitte überprüfe deine Bestellung bei Erhalt und kontaktiere uns sofort, wenn der Artikel defekt oder beschädigt ist oder wenn du einen falschen Artikel erhalten hast, damit wir das Problem auswerten und beheben können.</p>
<h3>Ausnahmen / nicht für eine Rückgabe berechtigte Artikel</h3>
<p>Bestimmte Artikel können nicht zurückgegeben werden, z. B. verderbliche Waren (z. B. Lebensmittel, Blumen oder Pflanzen), Sonderanfertigungen (z. B. Sonderbestellungen oder personalisierte Artikel) und persönliche Pflegeprodukte (z. B. Schönheitsprodukte). Wir akzeptieren auch keine Rückgaben von gefährlichen Materialien, entflammbaren Flüssigkeiten oder Gasen. Bitte setze dich mit uns in Verbindung, wenn du Fragen oder Bedenken zu einem speziellen Artikel hast.</p>
<p>Leider können wir keine Rückgaben von Angebotsartikeln oder Gutscheinen akzeptieren.</p>
<h3>Umtausch</h3>
<p>Die Rückgabe des erhaltenen Artikels ist der schnellste Weg, um den gewünschten Artikel zu erhalten. Wenn die Rückgabe akzeptiert wird, kannst du den neuen Artikel in einem separaten Kauf erwerben.</p>
<h3>Europäische Union – 14-tägige Widerrufsfrist</h3>
<p>Ungeachtet dessen hast du das Recht, deine Bestellung innerhalb von 14 Tagen ohne Angabe von Gründen zu stornieren oder zurückzugeben, wenn die Ware in die Europäische Union versendet wird. Wie oben beschrieben, muss sich der Artikel in demselben Zustand befinden, in dem du ihn erhalten hast, ungetragen, ungenutzt und mit Etiketten versehen sein und sich in der Originalverpackung befinden. Außerdem benötigst du den Beleg oder einen anderen Kaufnachweis.</p>
<h3>Rückerstattungen</h3>
<p>Wir werden dich benachrichtigen, sobald wir deine Rückgabe erhalten und geprüft haben, und dir mitteilen, ob die Rückerstattung genehmigt wurde oder nicht. Im Falle einer Genehmigung erhältst du innerhalb von 10 Werktagen eine automatische Rückerstattung auf deine ursprüngliche Zahlungsmethode. Bitte denke daran, dass es einige Zeit dauern kann, bis deine Bank oder dein Kreditkartenunternehmen die Erstattung bearbeitet und verbucht hat.</p>
<p>Wenn mehr als 15 Werktage vergangen sind, seit wir deine Rückgabe genehmigt haben, kontaktiere uns bitte unter <a href="mailto:info@keey.de">info@keey.de</a>.</p>
<div class="official">Amtliche Fassung: <a href="/pages/widerrufsrecht" target="_blank" rel="noopener">keey.de/pages/widerrufsrecht</a></div>`},
  datenschutz:{title:"Datenschutzerklärung",html:`
<p>Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO), ist: <b>KEEY GmbH</b></p>
<h3>Ihre Betroffenenrechte</h3>
<p>Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit folgende Rechte ausüben:</p>
<p class="lrow">• Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),</p>
<p class="lrow">• Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),</p>
<p class="lrow">• Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),</p>
<p class="lrow">• Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO),</p>
<p class="lrow">• Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO) und</p>
<p class="lrow">• Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO).</p>
<p>Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen.</p>
<p>Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an die zuständige Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die für uns als verantwortliche Stelle zuständige Behörde. Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift finden Sie unter: <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank" rel="noopener">bfdi.bund.de</a>.</p>
<h3>Cookies</h3>
<p>Wie viele andere Webseiten verwenden wir auch so genannte „Cookies". Bei Cookies handelt es sich um kleine Textdateien, die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere Webseite besuchen. Sie können einzelne Cookies oder den gesamten Cookie-Bestand löschen. Darüber hinaus erhalten Sie Informationen und Anleitungen, wie diese Cookies gelöscht oder deren Speicherung vorab blockiert werden können.</p>
<p><b>Technisch notwendige Cookies</b><br>Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann. Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für die Nutzer zu vereinfachen. Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an einer nutzerfreundlichen Gestaltung unserer Website.</p>
<h3>Registrierung auf unserer Website</h3>
<p>Für die Registrierung auf unserer Website benötigen wir einige personenbezogene Daten, die über eine Eingabemaske an uns übermittelt werden. Zum Zeitpunkt der Registrierung werden zusätzlich folgende Daten erhoben: Name, Mailadresse. Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage einer Einwilligung des Nutzers (Art. 6 Abs. 1 lit. a DSGVO). Daten werden in diesem Zusammenhang nur verarbeitet, solange die entsprechende Einwilligung vorliegt.</p>
<h3>Verwendung von Google Analytics</h3>
<p>Soweit Sie ihre Einwilligung gegeben haben, wird auf dieser Website Google Analytics eingesetzt, ein Webanalysedienst der Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043 USA. Google Analytics verwendet sog. „Cookies", also Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Webseite durch Sie ermöglichen. Aufgrund der Aktivierung der IP-Anonymisierung auf diesen Webseiten wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Die von uns gesendeten und mit Cookies, Nutzerkennungen oder Werbe-IDs verknüpften Daten werden nach 14 Monaten automatisch gelöscht.</p>
<h3>Verwendung von Scriptbibliotheken (Google Webfonts)</h3>
<p>Um unsere Inhalte browserübergreifend korrekt und grafisch ansprechend darzustellen, verwenden wir auf dieser Website „Google Web Fonts" der Google LLC zur Darstellung von Schriften. Weitere Informationen zu Google Web Fonts finden Sie unter <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener">developers.google.com/fonts/faq</a> und in der Datenschutzerklärung von Google: <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener">google.com/policies/privacy</a>.</p>
<h3>Verwendung von Typekit-Webschriftarten von Adobe Fonts</h3>
<p>Wir setzen Typekit-Webschriftarten von Adobe Fonts zur visuellen Gestaltung unserer Website ein. Adobe Fonts ist ein Dienst der Adobe Systems Software Ireland Companies. Zur Einbindung der von uns benutzten Schriftarten muss Ihr Browser eine Verbindung zu einem Server von Adobe in den USA aufbauen und die für unsere Website benötigte Schriftart herunterladen.</p>
<h3>Verwendung von Google Maps</h3>
<p>Auf dieser Website nutzen wir das Angebot von Google Maps. Dadurch können wir Ihnen interaktive Karten direkt in der Webseite anzeigen. Nähere Informationen über die Datenverarbeitung durch Google können Sie den Google-Datenschutzhinweisen entnehmen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">policies.google.com/privacy</a>.</p>
<h3>Eingebettete YouTube-Videos</h3>
<p>Auf unserer Website betten wir YouTube-Videos ein. Betreiber ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie eine Seite mit dem YouTube-Plugin besuchen, wird eine Verbindung zu Servern von YouTube hergestellt. Dabei wird YouTube mitgeteilt, welche Seiten Sie besuchen.</p>
<h3>Social Plugins</h3>
<p>Auf unserer Website werden Social Plugins eingesetzt. Wir verhindern die unbewusste und ungewollte Erfassung und Übertragung von Daten an den Diensteanbieter durch eine 2-Klick-Lösung. Erst durch die Aktivierung des Plugins wird auch die Erfassung von Informationen und deren Übertragung an den Diensteanbieter ausgelöst.</p>
<h3>Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO</h3>
<p>Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund Art. 6 Abs. 1 lit. f DSGVO erfolgt, Widerspruch einzulegen. Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</p>
<h3>Fragen an den Datenschutzbeauftragten</h3>
<p>Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation: <a href="mailto:info@keey.de">info@keey.de</a></p>
<p><i>Die Datenschutzerklärung wurde mithilfe der activeMind AG erstellt (Version #2020-09-30).</i></p>
<div class="official">Amtliche Fassung: <a href="/pages/datenschutzerklarung" target="_blank" rel="noopener">keey.de/pages/datenschutzerklarung</a></div>`}
};
function openLegal(e,key){
  if(typeof e === 'string'){key=e;e=null;}
  if(e && typeof e.preventDefault === 'function'){e.preventDefault();}
  const l=LEGAL[key];if(!l)return;
  document.getElementById("legalTitle").textContent=l.title;
  document.getElementById("legalBody").innerHTML=l.html;
  document.getElementById("legalBg").classList.add("open");
  document.body.style.overflow="hidden";
  document.querySelector(".legal-modal").scrollTop=0;
}
function closeLegal(){document.getElementById("legalBg").classList.remove("open");document.body.style.overflow="";}

/* ---------- ANFRAGE (Fragen-Buttons -> Mail) ---------- */
const afState={produkt:"",branche:"",menge:"",zeit:""};
function afPick(btn,group){
  afState[group]=btn.textContent.trim();
  const wrap=btn.closest(".afq-opts");
  wrap.querySelectorAll(".afq-opt").forEach(b=>b.classList.toggle("on",b===btn));
}
function afText(de,en){
  return document.documentElement.lang==="en"?en:de;
}
function afSend(){
  const name=(document.getElementById("afName").value||"").trim();
  const email=(document.getElementById("afEmail").value||"").trim();
  const phone=(document.getElementById("afPhone").value||"").trim();
  const msg=(document.getElementById("afMsg").value||"").trim();

  if(!afState.produkt&&!afState.branche&&!afState.menge&&!afState.zeit&&!name&&!email){
    toast(afText("Bitte waehle mindestens eine Option","Please select at least one option"));return;
  }

  const line=(l,v)=>v?l+": "+v+"\n":"";
  const body=
"Hallo KEEY-Team,\n\nich sende euch eine unverbindliche Anfrage:\n\n"+
line("Produkt",afState.produkt)+line("Branche",afState.branche)+line("Menge",afState.menge)+line("Zeitrahmen",afState.zeit)+
line("Name / Firma",name)+line("E-Mail",email)+line("Telefon",phone)+
(msg?"\nNachricht:\n"+msg+"\n":"")+
"\n>>> Bitte Logo / Design / Druckdatei direkt an diese E-Mail anhaengen. <<<\n"+
"\nBitte um ein persoenliches Angebot.\n\nViele Gruesse"+(name?"\n"+name:"");

  const subject="Unverbindliche Anfrage \u2013 KEEY PACK";
  window.location.href="mailto:info@keey.de?subject="+encodeURIComponent(subject)+"&body="+encodeURIComponent(body);
}

let individuellOpened=false;
function openIndividuell(e){
  if(e){e.preventDefault();}
  const inner=document.getElementById("individuellInner");
  if(!individuellOpened){
    inner.style.display="block";
    const gallery=document.getElementById("designGallery");
    const designs=[...SC_A,...SC_B];
    gallery.innerHTML=designs.map((key)=>{
      const brand=SC_BRAND[key]||"KEEY PACK Design";
      return '<figure class="design-card"><img loading="lazy" decoding="async" fetchpriority="low" src="'+SC_IMGS[key]+'" alt="'+brand+' – individuelles Verpackungsdesign von KEEY PACK"><figcaption>'+brand+'</figcaption></figure>';
    }).join('');
    inner.classList.add("shop-reveal");
    individuellOpened=true;
  }
  requestAnimationFrame(()=>{document.getElementById("individuell").scrollIntoView({behavior:"smooth",block:"start"});});
}

/* ---------- INIT ---------- */
buildChips();renderGrid();updateCart();

const UEBER_IMG_DATA=KA('inline-13-dbe86edcda6c.webp');
const DESIGN_IMG_DATA=KA('inline-14-1ffdcd8dcda6.webp');
document.getElementById("ueberImg").src=UEBER_IMG_DATA;
document.getElementById("designImg").src=DESIGN_IMG_DATA;

/* ---------- NAV HIDE ON SCROLL DOWN ---------- */
(function(){
  let last=0;const nav=document.getElementById("nav");
  window.addEventListener("scroll",()=>{
    const y=window.scrollY;
    if(y>last&&y>300){nav.classList.add("hide");}else{nav.classList.remove("hide");}
    last=y;
  },{passive:true});
})();

/* ===== I18N ===== */
(function(){
  const T = {
  "DEIN PACKAGING": "YOUR PACKAGING",
  "Individuelle Verpackungen & Druck": "Custom packaging & printing",
  "Verpackungen, die Ihre Marke sichtbar machen.": "Packaging that makes your brand visible.",
  "Individuell bedruckt": "Custom printed",
  "Nachhaltige Materialien": "Sustainable materials",
  "Schnelle Lieferung": "Fast delivery",
  "Premium Qualität": "Premium quality",
  "Viele Produkte aus einer Hand": "Many products, one source",
  "Flexible Bestellmengen": "Flexible order quantities",
  "Faire Preise": "Fair prices",
  "Persönliche Beratung": "Personal consultation",
  "KEEY PACK – Individuelle Verpackungen und Druck": "KEEY PACK – Custom packaging and printing",
  "KEEY PACK – Individuell bedruckte Verpackungen für Gastronomie & Retail": "KEEY PACK – Custom-printed packaging for gastronomy & retail",
  "KEEY PACK: individuell bedruckte Verpackungen für Gastronomie, Delivery, Coffee Shops und Retail. Pizzakartons, Becher, Bowls, Boxen und Tragetaschen aus einer Hand.": "KEEY PACK: custom-printed packaging for restaurants, delivery, coffee shops and retail. Pizza boxes, cups, bowls, boxes and carrier bags from one source.",
  "Produkte": "Products",
  "Shop": "Shop",
  "Individuell": "Custom",
  "Warenkorb": "Cart",
  "Bürobedarf": "Office supplies",
  "Designservice": "Design service",
  "Videos": "Videos",
  "Services": "Services",
  "Über KEEY": "About KEEY",
  "Anfrage": "Request",
  "Referenzen": "References",
  "Menü": "Menu",
  "KEEY PACK · Individuelle Verpackungen & Druck": "KEEY PACK · Custom packaging & printing",
  "Verpackungen, die Ihre": "Packaging that makes your",
  "Marke sichtbar machen.": "brand visible.",
  "Individuell bedruckte Lösungen für Gastronomie, Delivery, Coffee Shops & Retail – von Pizzakartons über Becher und Bowls bis zu Boxen und Tragetaschen.": "Custom-printed solutions for restaurants, delivery, coffee shops & retail – from pizza boxes, cups and bowls to boxes and carrier bags.",
  "Produkte konfigurieren ›": "Configure products ›",
  "Produkte konfigurieren  ›": "Configure products ›",
  "Projekt anfragen": "Request a project",
  "Pizzakartons": "Pizza boxes",
  "Becher & Bowls": "Cups & bowls",
  "Take-away Boxen": "Take-away boxes",
  "Tragetaschen": "Carrier bags",
  "Alles aus einer Hand": "Everything from one source",
  "Design, Druck, Verpackung und persönliche Beratung für dein Projekt.": "Design, printing, packaging and personal advice for your project.",
  "Für Gastronomie & Retail": "For gastronomy & retail",
  "Pizza, Burger, Coffee, Bowls, Bakery, Delivery und Markenboxen.": "Pizza, burger, coffee, bowls, bakery, delivery and branded boxes.",
  "Dein Logo, deine Farben und deine Botschaft direkt auf dem Produkt.": "Your logo, your colors and your message directly on the product.",
  "Schnelle Anfrage": "Fast request",
  "Produkt wählen, Menge bestimmen und ein individuelles Angebot erhalten.": "Choose a product, set the quantity and receive an individual quote.",
  "Produkt wählen, Menge bestimmen und anschließend sicher online bezahlen.": "Choose a product, set the quantity and then pay securely online.",
  "Inspiration für deine Marke.": "Inspiration for your brand.",
  "Von Pizza-Slices über Sushi-Boxen bis zu Tragetaschen und Pâtisserie – individuell bedruckt für Gastronomie, Coffee Shops und Retail.": "From pizza slices and sushi boxes to carrier bags and pâtisserie – custom-printed for gastronomy, coffee shops and retail.",
  "Individuelle Markenwelten": "Distinctive brand worlds",
  "Dein Design.": "Your design.",
  "Deine Idee verdient eine Verpackung, die im Gedächtnis bleibt. Entdecke individuelle Designs für Gastronomie, Coffee Shops, Retail und besondere Marken – von der ersten Skizze bis zur druckfertigen Verpackung entwickeln wir gemeinsam einen Auftritt, der unverwechselbar zu dir passt.": "Your idea deserves packaging that stays in people’s minds. Discover custom designs for restaurants, coffee shops, retail and distinctive brands – from the first sketch to print-ready packaging, we create an identity together that is unmistakably yours.",
  "Dein Projekt starten  ›": "Start your project  ›",
  "Produktübersicht": "Product overview",
  "Alle Verpackungen auf einen Blick": "All packaging at a glance",
  "Entdecken Sie unsere wichtigsten Produktgruppen – modern präsentiert und direkt konfigurierbar.": "Discover our most important product groups – presented in a modern way and directly configurable.",
  "Alle Preise netto inkl. Druck.": "All prices are net and include printing.",
  "Alle Produktpreise netto inkl. Druck · Versand in Deutschland im Checkout.": "All product prices are net and include printing · shipping within Germany at checkout.",
  "5 Millionen": "5 Million",
  "5 Millionen Druckprodukte": "5 Million printed products",
  "Druckprodukte": "printed products",
  "haben wir seit 2019 gedruckt – für Marken, die Eindruck hinterlassen.": "printed since 2019 – for brands that leave an impression.",
  "Video Einblicke": "Video insights",
  "Unsere Verpackungen in Aktion.": "Our packaging in action.",
  "Kurze Einblicke in Druck, Muster, Branding und fertige Verpackungslösungen – damit Kunden sofort sehen, wie KEEY PACK wirkt.": "Short insights into printing, samples, branding and finished packaging solutions – so customers immediately see the impact of KEEY PACK.",
  "Produktion": "Production",
  "Weitere Video-Einblicke ansehen": "View more video insights",
  "Weniger Videos anzeigen": "Show fewer videos",
  "Mehr entdecken": "Discover more",
  "Weitere Projekte in Bewegung": "More projects in motion",
  "Verpackung, die auffällt": "Packaging that stands out",
  "Marken sichtbar machen": "Making brands visible",
  "Vom Entwurf zum Produkt": "From design to product",
  "Details, die Eindruck machen": "Details that make an impression",
  "Individuell für deine Marke": "Custom for your brand",
  "Verpackungen im Einsatz": "Packaging in use",
  "Qualität zum Anfassen": "Quality you can feel",
  "Design trifft Funktion": "Design meets function",
  "Ideen werden Verpackung": "Ideas become packaging",
  "Verpackungen im echten Einsatz": "Packaging in real use",
  "Druckqualität, die sichtbar bleibt": "Print quality that stays visible",
  "Deine Marke auf jedem Produkt": "Your brand on every product",
  "Von der Idee bis zur Verpackung": "From idea to packaging",
  "Die Videos starten automatisch ohne Ton. Dadurch bleibt die Seite ruhig, modern und mobilfreundlich.": "The videos start automatically without sound. This keeps the page calm, modern and mobile-friendly.",
  "Marken, die auf KEEY setzen": "Brands that rely on KEEY",
  "Konfigurator": "Configurator",
  "Stell dir deine Verpackung zusammen": "Build your packaging",
  "Tippe auf ein Produkt, um Größe, Menge und Druck zu konfigurieren.": "Tap a product to configure size, quantity and printing.",
  "Kategorie": "Category",
  "Branche": "Industry",
  "Kein Produkt gefunden.": "No product found.",
  "Frag uns direkt": "Contact us directly",
  "– wir produzieren auch Sonderformate.": "– we also produce custom formats.",
  "Briefumschläge, Etiketten & mehr": "Envelopes, labels & more",
  "Sofort verfügbare Standardprodukte zu Festpreisen – direkt in den Warenkorb legen.": "Immediately available standard products at fixed prices – add directly to the cart.",
  "Größe": "Size",
  "Material": "Material",
  "Deckel auswählen": "Choose a lid",
  "Dom Deckel": "Dome lid",
  "Flacher Deckel": "Flat lid",
  "Trinkdeckel": "Sipper lid",
  "Menge": "Quantity",
  "Mindestmenge 1.000 Stück": "Minimum quantity 1,000 pcs",
  "Druckfarben": "Print colors",
  "1–4 Farben": "1–4 colors",
  "Netto": "Net",
  "Brutto": "Gross",
  "inkl. 19% MwSt": "incl. 19% VAT",
  "Geschätzter Richtpreis. Finaler Preis im persönlichen Angebot.": "Estimated guide price. Final price in your personal quote.",
  "Produktpreis inkl. individuellem Druck. Versand in Deutschland wird im sicheren Checkout angezeigt.": "Product price includes custom printing. Shipping within Germany is shown in the secure checkout.",
  "Zum Warenkorb hinzufügen": "Add to cart",
  "Anfrage ansehen": "View request",
  "Warenkorb ansehen": "View cart",
  "Dein Warenkorb": "Your cart",
  "Zwischensumme netto": "Subtotal net",
  "Richtpreise. Mengen oben anpassbar – die Summe wird automatisch neu berechnet.": "Guide prices. Quantities can be adjusted above – the total is recalculated automatically.",
  "Mengen oben anpassbar – die Summe wird automatisch neu berechnet.": "Quantities can be adjusted above – the total is recalculated automatically.",
  "Bestellung überprüfen ›": "Review order ›",
  "Weiter zur Bestellliste ›": "Continue to order list ›",
  "Weiter zur Bestellliste  ›": "Continue to order list ›",
  "Weiter zur Bestellliste &nbsp;›": "Continue to order list ›",
  "Weiter einkaufen": "Continue shopping",
  "‹ Zurück": "‹ Back",
  "Bestellliste": "Order list",
  "Summe netto": "Total net",
  "Summe brutto": "Total gross",
  "Erstelle ein Angebot mit allen Positionen, Preisen und deinen Kontaktdaten – als PDF speichern oder direkt per E-Mail senden.": "Create a quote with all items, prices and your contact details – save as PDF or send directly by email.",
  "Sichere Zahlung über Shopify Checkout. Lieferadresse und Versand in Deutschland werden dort bestätigt.": "Secure payment via Shopify Checkout. Delivery address and shipping within Germany are confirmed there.",
  "Sicher bestellen & bezahlen ›": "Order & pay securely ›",
  "Angebot / Bestellung erstellen ›": "Create quote / order ›",
  "Liste kopieren": "Copy list",
  "Angebot": "Quote",
  "Bestellung": "Order",
  "PDF herunterladen": "Download PDF",
  "Bestellung als PDF": "Order as PDF",
  "Sicher bezahlen": "Pay securely",
  "Kreditkarte · PayPal · Klarna · Apple Pay – abhängig von den aktivierten Shopify-Zahlungsarten.": "Credit card · PayPal · Klarna · Apple Pay – depending on the enabled Shopify payment methods.",
  "Drucken": "Print",
  "Per E-Mail senden": "Send by email",
  "Dein Design – so einzigartig wie deine Marke.": "Your design – as unique as your brand.",
  "Unser Designteam entwickelt gemeinsam mit dir dein Wunschdesign – schon ab kleinen Stückzahlen. Individuell, stilvoll und ganz auf deine Marke abgestimmt. Inklusive 3D-Vorschau zur Freigabe.": "Our design team develops your desired design together with you – even from small quantities. Individual, stylish and tailored to your brand. Including a 3D preview for approval.",
  "Musterbox": "Sample box",
  "Teste unsere Qualität. Überzeug dich selbst.": "Test our quality. See for yourself.",
  "Fordere deine persönliche Musterbox an und erlebe unsere Produkte live – Tüten, Tragetaschen und Einschlagpapiere. So bekommst du direkt ein Gefühl für Materialien und Verarbeitung. Innerhalb der EU liefern wir deine Musterbox kostenlos.": "Request your personal sample box and experience our products live – bags, carrier bags and wrapping papers. This gives you a direct feel for materials and workmanship. Within the EU, we deliver your sample box free of charge.",
  "Fordere deine persönliche Musterbox an und erlebe unsere Produkte live – Tüten, Tragetaschen und Einschlagpapiere. So bekommst du direkt ein Gefühl für Materialien und Verarbeitung. Innerhalb der EU liefern wir versandkostenfrei.": "Request your personal sample box and experience our products live – bags, carrier bags and wrapping papers. This gives you a direct feel for materials and workmanship. We deliver within the EU free of shipping costs.",
  "Muster anfragen": "Request samples",
  "Mehr als nur Verpackung.": "More than just packaging.",
  "Drei Services, die dein Wachstum einfacher machen.": "Three services that make your growth easier.",
  "Keey-Warehouse": "KEEY Warehouse",
  "Mehr Platz. Weniger Aufwand.": "More space. Less effort.",
  "Bestelle in großen Stückzahlen, lagere effizient bei uns ein – und wir übernehmen den kostenlosen Versand an deine Wunschadressen. Senke Lagerkosten und vereinfache deine Lieferprozesse.": "Order in large quantities, store efficiently with us – and we handle free shipping to your chosen addresses. Reduce storage costs and simplify your delivery processes.",
  "Lizenz-Service": "Licensing service",
  "Rechtlich abgesichert verpacken.": "Package with legal peace of mind.",
  "Verlass dich auf unsere Erfahrung rund um Verpackungslizenzen und gesetzliche Vorgaben. Wir lizenzieren deine Verpackungen korrekt – damit du entspannt und rechtssicher verkaufst.": "Rely on our experience with packaging licenses and legal requirements. We license your packaging correctly – so you can sell with confidence.",
  "Nachhaltigkeit": "Sustainability",
  "Gemeinsam etwas zurückgeben.": "Giving something back together.",
  "Mit jeder Bestellung unterstützt du ausgewählte soziale und ökologische Projekte – und setzt ein sichtbares Zeichen für Verantwortung und Nachhaltigkeit.": "With every order, you support selected social and ecological projects – and make responsibility and sustainability visible.",
  "Verpackung ist nicht nur unser Job. Sie ist unsere Leidenschaft.": "Packaging is not just our job. It is our passion.",
  "Verpackung ist der erste Eindruck – der erste Kontakt mit deiner Marke. Wir entwickeln individuelle Lösungen für Unternehmen, die Wert auf Qualität, Design und Wirkung legen. Wir arbeiten nicht nur für große Marken, sondern auch für Start-ups, Gastronomie und kreative Projekte, die sichtbar werden wollen.": "Packaging is the first impression – the first contact with your brand. We develop individual solutions for companies that value quality, design and impact. We work not only for big brands, but also for start-ups, restaurants and creative projects that want to become visible.",
  "Verpackung ist der erste Eindruck – der erste Kontakt mit deiner Marke. Wir entwickeln individuelle Lösungen für Unternehmen, die Wert auf Qualität, Design und Wirkung legen. Wir arbeiten nicht nur für Marken. Wir denken wie Marken – und liefern, was Marken stark macht: sichtbare Qualität.": "Packaging is the first impression – the first contact with your brand. We develop custom solutions for companies that value quality, design and impact. We do not just work for brands. We think like brands – and deliver what makes brands strong: visible quality.",
  "Jetzt konfigurieren": "Configure now",
  "Darum setzen Marken auf uns.": "Why brands choose us.",
  "Die Verpackung war nicht nur hochwertig, sondern hat unser Produkt perfekt ergänzt. Lieferung war schnell und der Service erstklassig!": "The packaging was not only high quality, it complemented our product perfectly. Delivery was fast and the service was excellent!",
  "Laura M. · Gründerin von Bloom & Paper": "Laura M. · Founder of Bloom & Paper",
  "Wir sind begeistert von der Qualität und Zuverlässigkeit. Unser Branding kommt endlich so zur Geltung, wie es soll.": "We are impressed by the quality and reliability. Our branding finally comes across exactly as it should.",
  "Jonas W. · CEO von Leafy Goods": "Jonas W. · CEO of Leafy Goods",
  "Unverbindliche Anfrage": "Non-binding request",
  "Erzähl uns von deinem Projekt.": "Tell us about your project.",
  "Beantworte ein paar kurze Fragen – wir melden uns innerhalb von 24 h mit einem persönlichen Angebot.": "Answer a few short questions – we will get back to you within 24 hours with a personal quote.",
  "Beantworte ein paar kurze Fragen – wir melden uns innerhalb von 24\u00A0h mit einem persönlichen Angebot.": "Answer a few short questions – we will get back to you within 24 hours with a personal quote.",
  "1 · Was möchtest du produzieren?": "1 · What would you like to produce?",
  "Bedruckte Verpackungen": "Printed packaging",
  "Bürobedarf (Umschläge, Etiketten)": "Office supplies (envelopes, labels)",
  "Individuelles Design": "Custom design",
  "Noch unklar / Beratung": "Not sure yet / consultation",
  "2 · Aus welcher Branche kommst du?": "2 · Which industry are you from?",
  "Gastronomie": "Gastronomy",
  "Bäckerei": "Bakery",
  "Handel / E-Commerce": "Retail / e-commerce",
  "Konzern / Industrie": "Corporate / industry",
  "Sonstige": "Other",
  "3 · Welche Menge planst du?": "3 · What quantity are you planning?",
  "Bis 1.000": "Up to 1,000",
  "1.000 – 10.000": "1,000 – 10,000",
  "10.000 – 50.000": "10,000 – 50,000",
  "Über 50.000": "Over 50,000",
  "4 · Wie schnell brauchst du es?": "4 · How quickly do you need it?",
  "So schnell wie möglich": "As soon as possible",
  "In 1–2 Monaten": "In 1–2 months",
  "Nur Information / Preise": "Information / prices only",
  "Logo, Design oder Druckdatei hochladen": "Upload logo, design or print file",
  "JPG, PNG, PDF, SVG, AI, EPS oder ZIP · mehrere Dateien möglich": "JPG, PNG, PDF, SVG, AI, EPS or ZIP · multiple files possible",
  "Logo, Design oder Druckdatei? Bitte einfach an die E-Mail anhängen, die sich nach dem Klick öffnet.": "Logo, design or print file? Simply attach it to the email that opens after clicking.",
  "Unverbindliche Anfrage senden": "Send non-binding request",
  "Kostenlos & unverbindlich · Logo/Design möglich · Antwort innerhalb von 24 h · info@keey.de": "Free & non-binding · logo/design possible · reply within 24 h · info@keey.de",
  "Kostenlos & unverbindlich · Logo/Design möglich · Antwort innerhalb von 24\u00A0h · info@keey.de": "Free & non-binding · logo/design possible · reply within 24 h · info@keey.de",
  "Folge KEEY": "Follow KEEY",
  "Sichere Zahlung": "Secure payment",
  "Käuferschutz & verschlüsselte Zahlung über den KEEY Shop": "Buyer protection & encrypted payment via the KEEY shop",
  "Bereit, deine Marke": "Ready to make your brand",
  "sichtbar zu machen?": "visible?",
  "Stell dir im Konfigurator deine Verpackungen zusammen oder sende uns direkt eine Anfrage.": "Configure your packaging in the configurator or send us a request directly.",
  "Zum Konfigurator": "To the configurator",
  "Die Verpackung hinter erfolgreichen Marken. Individuell bedruckt, nachhaltig produziert in Europa.": "The packaging behind successful brands. Custom-printed and sustainably produced in Europe.",
  "Unternehmen": "Company",
  "Rechtliches": "Legal",
  "AGB": "Terms & Conditions",
  "Impressum": "Legal notice",
  "Widerrufsrecht": "Right of withdrawal",
  "Datenschutz": "Privacy policy",
  "© 2026 KEEY GmbH. Alle Rechte vorbehalten. · Build K-0626-B": "© 2026 KEEY GmbH. All rights reserved. · Build K-0626-B",
  "Produkt suchen … z. B. Pizzabox, Becher, Tüte": "Search product … e.g. pizza box, cup, bag",
  "Schließen": "Close",
  "Straße & Hausnr.": "Street & house no.",
  "PLZ & Ort": "Postal code & city",
  "Firma": "Company",
  "Ansprechpartner": "Contact person",
  "Datum": "Date",
  "Gültig bis": "Valid until",
  "Positionen": "items",
  "Beschreibung": "Description",
  "Einzelpreis": "Unit price",
  "Gesamt": "Total",
  "zzgl. 19% MwSt.": "plus 19% VAT",
  "Anmerkungen:": "Notes:",
  "Hinweise:": "Notes:",
  "Kontakt": "Contact",
  "Register": "Register",
  "Geschäftsführer:": "Managing director:",
  "Bestellung von": "Order from",
  "Angebot für": "Quote for",
  "Bestell-Nr.": "Order no.",
  "Angebots-Nr.": "Quote no.",
  "Verbindliche Bestellung – alle Preise netto zzgl. 19% MwSt., inkl. Druck.": "Binding order – all prices net plus 19% VAT, incl. printing.",
  "Unverbindliches Angebot – alle Preise netto zzgl. 19% MwSt., inkl. Druck.": "Non-binding quote – all prices net plus 19% VAT, incl. printing.",
  "Dieses Angebot ist freibleibend und 30 Tage gültig.": "This quote is non-binding and valid for 30 days.",
  "Alle Preise verstehen sich netto in Euro zzgl. 19% MwSt. und inkl. Druck. Finale Druckdaten und Freigabe werden separat abgestimmt. Es gelten die AGB der KEEY GmbH. Maßgeblich ist die deutsche Fassung. / The German version is legally binding.": "All prices are net in euros plus 19% VAT and include printing. Final print files and approval are coordinated separately. The terms and conditions of KEEY GmbH apply.",
  "Mit dem Absenden dieser Bestellung beauftragst du KEEY mit der Produktion der oben genannten Positionen.": "By sending this order, you commission KEEY to produce the items listed above.",
  "Alle": "All",
  "Alle Anwendungen": "All applications",
  "Becher": "Cups",
  "Kaffeebecher": "Coffee cups",
  "Bowls": "Bowls",
  "Clear Cups": "Clear cups",
  "Pizzakartons": "Pizza boxes",
  "Gastronomie": "Gastronomy",
  "Bowls inkl. Druck": "Bowls incl. printing",
  "500 ml bis 1300 ml · optional mit PET-Deckel": "500 ml to 1300 ml · optional PET lid",
  "500 ml mit PET Deckel": "500 ml with PET lid",
  "750 ml mit PET Deckel": "750 ml with PET lid",
  "900 ml mit PET Deckel": "900 ml with PET lid",
  "1000 ml mit PET Deckel": "1000 ml with PET lid",
  "1300 ml mit PET Deckel": "1300 ml with PET lid",
  "Stückpreis netto inkl. Druck": "Unit price net incl. printing",
  "Becher inkl. Druck": "Cups incl. printing",
  "Kaffeebecher inkl. Druck": "Coffee cups incl. printing",
  "4 oz, 8 oz und 12 oz – jeweils mit Deckel": "4 oz, 8 oz and 12 oz – each with lid",
  "Kaffeebecher in 4 oz, 8 oz und 12 oz – jeweils mit Deckel": "Coffee cups in 4 oz, 8 oz and 12 oz – each with lid",
  "4 oz mit Deckel": "4 oz with lid",
  "8 oz mit Deckel": "8 oz with lid",
  "12 oz mit Deckel": "12 oz with lid",
  "Clear Cup inkl. Druck": "Clear cup incl. printing",
  "250 ml, 350 ml, 500 ml · Deckel optional": "250 ml, 350 ml, 500 ml · lid optional",
  "Ohne Deckel": "Without lid",
  "Mit Deckel (+0,03 € / Stk)": "With lid (+0.03 € / pc)",
  "Stückpreis netto inkl. Druck · Deckel optional": "Unit price net incl. printing · lid optional",
  "Tablettpapier": "Tray paper",
  "Papiere": "Papers",
  "Markenpapier für Tabletts und Food-Präsentation": "Branded paper for trays and food presentation",
  "Markenpapier für Tabletts und Food-Präsentation · 30 × 40 cm und 31 × 43 cm": "Branded paper for trays and food presentation · 30 × 40 cm and 31 × 43 cm",
  "Burger Box": "Burger box",
  "Boxen": "Boxes",
  "Individuell bedruckte Burger- und Take-away-Boxen": "Custom-printed burger and take-away boxes",
  "Individuell bedruckte Burger- und Take-away-Boxen · 11 × 11 × 8 cm und 12 × 12 × 9,5 cm": "Custom-printed burger and take-away boxes · 11 × 11 × 8 cm and 12 × 12 × 9.5 cm",
  "Erfrischungstücher": "Refreshing wipes",
  "Hygiene": "Hygiene",
  "Individuell bedruckte Erfrischungstücher · 7 × 12 cm oder als Press Tücher": "Custom-printed refreshing wipes · 7 × 12 cm or compressed towels",
  "Press Tücher": "Compressed towels",
  "Tragetasche ohne Henkel": "Carrier bag without handles",
  "Taschen": "Bags",
  "Papiertragetasche ohne Henkel": "Paper carrier bag without handles",
  "Papiertragetasche ohne Henkel · 27 × 15 × 33 cm": "Paper carrier bag without handles · 27 × 15 × 33 cm",
  "Tragetasche mit Henkel": "Carrier bag with handles",
  "Papiertragetasche mit Henkel · 27 × 15 × 33 cm": "Paper carrier bag with handles · 27 × 15 × 33 cm",
  "Stückpreis netto inkl. Druck · mit Henkel (+0,04 € / Stk)": "Unit price net incl. printing · with handles (+0.04 € / pc)",
  "Wickelpapier 30×30 cm": "Wrapping paper 30×30 cm",
  "Bedrucktes Wickelpapier für Döner, Snacks und Take-away · 30 × 30 cm": "Printed wrapping paper for kebab, snacks and take-away · 30 × 30 cm",
  "Dönerpapier 16×16 cm": "Kebab paper 16×16 cm",
  "Bedrucktes Einschlagpapier für Döner & Snacks": "Printed wrapping paper for kebab & snacks",
  "Bedrucktes Dönerpapier für Döner & Snacks · 16 × 16 cm": "Printed kebab paper for kebab & snacks · 16 × 16 cm",
  "Pizzakarton": "Pizza box",
  "Bestellen": "Order",
  "Zur Bestellung ›": "Order now ›",
  "ab": "from",
  "Stk": "pcs",
  "Stück": "pieces",
  "inkl. Druck": "incl. printing",
  "Druck": "Printing",
  "inklusive": "included",
  "Individueller Druck ist bereits im Preis enthalten.": "Custom printing is already included in the price.",
  "Zum Warenkorb hinzugefügt": "Added to cart",
  "Warenkorb ist leer": "Cart is empty",
  "Dein Warenkorb ist leer": "Your cart is empty",
  "Wähle ein Produkt aus der Produktübersicht.": "Choose a product from the product overview.",
  "Keine Positionen.": "No items.",
  "Liste ist leer": "The list is empty",
  "Liste kopiert": "List copied",
  "Kopieren nicht möglich": "Copying not possible",
  "PDF wird erstellt …": "Creating PDF …",
  "PDF gespeichert": "PDF saved",
  "PDF-Erstellung fehlgeschlagen – Druckdialog wird geöffnet": "PDF creation failed – print dialog will open",
  "Briefumschläge": "Envelopes",
  "Etiketten": "Labels",
  "Papier": "Paper",
  "Selbstklebende Etiketten": "Self-adhesive labels",
  "Druckerpapier": "Printer paper",
  "Kraftpapier": "kraft paper",
  "MIT Fenster": "WITH window",
  "OHNE Fenster": "WITHOUT window",
  "Fenster": "window",
  "weiß": "white",
  "Blatt": "sheets",
  "Rolle": "roll",
  "Merken": "Save",
  "Schnellansicht": "Quick view",
  "Vergleichen": "Compare",
  "Vergleichen – bald verfügbar": "Compare – coming soon",
  "In den Warenkorb": "Add to cart",
  "✓ Im Warenkorb": "✓ In cart",
  "Ausverkauft": "Sold out",
  "Leider ausverkauft": "Unfortunately sold out",
  "inkl. MwSt": "incl. VAT",
  "netto": "net",
  "brutto": "gross",
  "Position": "item"
};
  const ATTRS = ['placeholder','title','aria-label','alt','value'];
  const originals = new WeakMap();
  const attrOriginal = new WeakMap();
  let lang = localStorage.getItem('keeyLang') || 'de';
  let applying = false;

  function preserve(src, out){
    const lead = (src.match(/^\s*/) || [''])[0];
    const trail = (src.match(/\s*$/) || [''])[0];
    return lead + out + trail;
  }
  function translatePhrase(s){
    if(!s || !s.trim()) return s;
    const raw=s;
    let x=s.trim();
    if(T[x]) return preserve(raw,T[x]);
    // dynamic numbers and prices
    x=x.replace(/Kostenlos & unverbindlich · Logo\/Design möglich · Antwort innerhalb von 24[\s\u00A0]*h · info@keey\.de/g, "Free & non-binding · logo/design possible · reply within 24 h · info@keey.de");
    x=x.replace(/Beantworte ein paar kurze Fragen – wir melden uns innerhalb von 24[\s\u00A0]*h with einem persönlichen quote\./gi, 'Answer a few short questions – we will get back to you within 24 hours with a personal quote.');
    x=x.replace(/Beantworte ein paar kurze Fragen – wir melden uns innerhalb von 24[\s\u00A0]*h mit einem persönlichen Angebot\./g, 'Answer a few short questions – we will get back to you within 24 hours with a personal quote.');
    x=x.replace(/(\d+) Produkte/g, '$1 products');
    x=x.replace(/(\d+) Positionen/g, '$1 items').replace(/(\d+) Position/g, '$1 item');
    x=x.replace(/Mindestmenge ([\d.]+) Stück/g, 'Minimum quantity $1 pcs');
    x=x.replace(/(\d+[.,]?\d*) Stück/g, '$1 pcs').replace(/(\d+[.,]?\d*) Stk/g, '$1 pcs');
    x=x.replace(/ab ([0-9,.]+) € \/ Stk/g, 'from $1 € / pc');
    x=x.replace(/netto/g,'net').replace(/brutto/g,'gross').replace(/inkl\. Druck/g,'incl. printing').replace(/inkl\. MwSt/g,'incl. VAT').replace(/inkl\. 19% MwSt/g,'incl. 19% VAT').replace(/Versand in Deutschland/g,'shipping within Germany');
    x=x.replace(/Stückpreis netto inkl\. Druck/g,'Unit price net incl. printing');
    x=x.replace(/Deckel/g,'lid').replace(/mit PET/g,'with PET').replace(/mit/g,'with').replace(/Ohne/g,'Without');
    x=x.replace(/Weiter zur Bestellliste[\s\u00A0]*›/g,'Continue to order list ›');
    x=x.replace(/Zur Bestellung ›/g,'Order now ›').replace(/Bestellen/g,'Order').replace(/In den Warenkorb/g,'Add to cart').replace(/Ausverkauft/g,'Sold out');
    x=x.replace(/Briefumschläge/g,'Envelopes').replace(/Selbstklebende Etiketten/g,'Self-adhesive labels').replace(/Etiketten/g,'Labels').replace(/Druckerpapier/g,'Printer paper').replace(/Kraftpapier/g,'kraft paper').replace(/Blatt/g,'sheets').replace(/weiß/g,'white');
    x=x.replace(/MIT Fenster/g,'WITH window').replace(/OHNE Fenster/g,'WITHOUT window');
    x=x.replace(/Menge/g,'Quantity').replace(/Größe/g,'Size').replace(/Material/g,'Material').replace(/Druckfarben/g,'Print colors');
    x=x.replace(/Becher/g,'Cups').replace(/Pizzakartons/g,'Pizza boxes').replace(/Gastronomie/g,'Gastronomy');
    x=x.replace(/Warenkorb/g,'cart').replace(/Angebot/g,'quote').replace(/Bestellung/g,'order');
    return preserve(raw,x);
  }
  function applyTextNode(n){
    if(!n.nodeValue || !n.nodeValue.trim()) return;
    if(lang==='de'){
      if(originals.has(n) && n.nodeValue !== originals.get(n)) n.nodeValue = originals.get(n);
      return;
    }
    const prev = originals.get(n);
    const prevTr = prev ? translatePhrase(prev) : null;
    let source;
    if(prev && n.nodeValue === prevTr) return;
    source = n.nodeValue;
    originals.set(n, source);
    const tr = translatePhrase(source);
    if(tr !== n.nodeValue) n.nodeValue = tr;
  }
  function applyAttrs(el){
    if(el.nodeType!==1) return;
    if(el.closest && el.closest('[data-no-translate]')) return;
    ATTRS.forEach(a=>{
      if(!el.hasAttribute(a)) return;
      let store = attrOriginal.get(el); if(!store){ store={}; attrOriginal.set(el,store); }
      if(lang==='de'){ if(store[a] && el.getAttribute(a)!==store[a]) el.setAttribute(a,store[a]); return; }
      const current=el.getAttribute(a);
      if(!store[a] || current!==translatePhrase(store[a])) store[a]=current;
      const tr=translatePhrase(store[a]); if(tr!==current) el.setAttribute(a,tr);
    });
  }
  function walk(root){
    if(!root || applying) return;
    applying=true;
    try{
      const walker=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {acceptNode(node){
        const p=node.parentElement; if(!p) return NodeFilter.FILTER_REJECT;
        if(['SCRIPT','STYLE','NOSCRIPT','TEXTAREA'].includes(p.tagName)) return NodeFilter.FILTER_REJECT;
        if(p.closest && p.closest('[data-no-translate]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }});
      const nodes=[]; while(walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(applyTextNode);
      if(root.nodeType===1){ applyAttrs(root); root.querySelectorAll('*').forEach(applyAttrs); }
      document.documentElement.lang = lang;
      document.title = lang==='en' ? 'KEEY PACK – Custom-printed packaging for gastronomy & retail' : 'KEEY PACK – Individuell bedruckte Verpackungen für Gastronomie & Retail';
      document.querySelectorAll('[data-lang-btn]').forEach(b=>b.classList.toggle('active', b.dataset.langBtn===lang));
    } finally { applying=false; }
  }
  window.setKeeyLang=function(next){
    lang = next==='en' ? 'en' : 'de';
    localStorage.setItem('keeyLang', lang);
    walk(document.body);
    setTimeout(()=>walk(document.body),50);
  };
  const mo = new MutationObserver(muts=>{
    if(applying) return;
    if(lang==='en') setTimeout(()=>walk(document.body),0);
    else document.querySelectorAll('[data-lang-btn]').forEach(b=>b.classList.toggle('active', b.dataset.langBtn===lang));
  });
  function init(){
    document.querySelectorAll('[data-lang-btn]').forEach(b=>b.classList.toggle('active', b.dataset.langBtn===lang));
    mo.observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:ATTRS});
    walk(document.body);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ===== HERO POINTER ===== */
  (()=>{
    const stage=document.querySelector('.khero-stage');
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer=window.matchMedia('(hover: hover) and (pointer: fine)');
    if(!stage || reduce.matches || !finePointer.matches) return;

    const orbit=stage.querySelector('.khero-product-orbit');
    const sweep=stage.querySelector('.khero-sweep');
    let frame=0, point={x:0,y:0};

    // Ambient mouse glow + sweep + a gentle whole-cluster depth drift.
    // The continuous levitation of each product lives in pure CSS keyframes;
    // here we only add atmosphere, so the float and pause-on-hover stay smooth.
    function render(){
      frame=0;
      const rect=stage.getBoundingClientRect();
      const x=Math.max(0,Math.min(rect.width,point.x-rect.left));
      const y=Math.max(0,Math.min(rect.height,point.y-rect.top));
      const nx=x/rect.width, ny=y/rect.height;
      stage.style.setProperty('--glow-x',`${(nx*100).toFixed(1)}%`);
      stage.style.setProperty('--glow-y',`${(ny*100).toFixed(1)}%`);
      if(sweep){
        sweep.style.setProperty('--sweep-x',`${Math.round(x-rect.width*.39-110)}px`);
        sweep.style.setProperty('--sweep-y',`${Math.round(y-120)}px`);
      }
      if(orbit){
        // cluster drifts opposite to the cursor → reads as parallax depth
        orbit.style.setProperty('--ox',`${Math.round((nx-.5)*-26)}px`);
        orbit.style.setProperty('--oy',`${Math.round((ny-.5)*-18)}px`);
      }
    }
    function move(event){
      point={x:event.clientX,y:event.clientY};
      stage.classList.add('is-pointer-active');
      if(!frame) frame=requestAnimationFrame(render);
    }
    function leave(){
      stage.classList.remove('is-pointer-active');
      if(orbit){
        orbit.style.setProperty('--ox','0px');
        orbit.style.setProperty('--oy','0px');
      }
    }
    stage.addEventListener('pointermove',move,{passive:true});
    stage.addEventListener('pointerleave',leave,{passive:true});
  })();

/* ===== COOKIE BANNER ===== */
// Cookie Banner Management
(function() {
  const banner = document.getElementById('cookieBanner');
  const cookieConsent = localStorage.getItem('cookieConsent');
  
  if (!cookieConsent) {
    setTimeout(() => {
      banner.classList.add('show');
    }, 1000);
  }
  
  window.acceptCookies = function() {
    localStorage.setItem('cookieConsent', 'accepted');
    banner.classList.remove('show');
    // Activate analytics
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };
  
  window.declineCookies = function() {
    localStorage.setItem('cookieConsent', 'declined');
    banner.classList.remove('show');
    // Disable analytics
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };
})();

// Legal Modal Management


/* Kategori sayfalarından gelen "Jetzt konfigurieren" linkleri için:
   ?open=<product-id> parametresi varsa ilgili ürünün konfigüratörünü otomatik açar. */
(function(){
  try{
    const params = new URLSearchParams(window.location.search);
    const openId = params.get('open');
    if(!openId) return;
    const run = function(){
      try{
        const p = productById(openId);
        if(p){
          const shopEl = document.getElementById('shop');
          if(shopEl){ openShop(); }
          setTimeout(function(){ openConfig(openId); }, 200);
        }
      }catch(e){ /* ürün bulunamadıysa sessizce yoksay */ }
    };
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
  }catch(e){}
})();
